import React, { useState, useEffect } from 'react';
import '../styles/Bestellen.css';
import { getApiBaseUrl } from '../utils/apiConfig';
import { useTranslation } from 'react-i18next';
import { FaPlus } from 'react-icons/fa';
import { toast } from 'react-toastify';
import menuImage from '../assets/images/6.png';
// import menuImage1 from '../assets/images/10 (2).png';
//import sakeImg from '../assets/images/6.png';
//import tekkaImg from '../assets/images/6.png';
//import ebiImg from '../assets/images/6.png';
import { useCart } from '../context/CartContext';
//import sommerllen from '../assets/images/sommerllen1.png';
//import somA from '../assets/images/7 (2).png';
//import somB from '../assets/images/8 (2).png';
import somC from '../assets/images/9 (2).png';
//import somD from '../assets/images/12 (2).png';
import EDAMAME from '../assets/images/EDAMAME.png';
//import WTSuppe from '../assets/images/WAN TAN SUPPE.png';
import TVGsupppe from '../assets/images/TOM YAM GUNG (SCHARF).png';
import MINIFVEGAN from '../assets/images/MINI FRÜHLINGSROLLEN (VEGAN.png';
import sommerollenC from '../assets/images/sommerollenC.png';
import sommerollenA from '../assets/images/sommerollenA.png';
import sommerollenD from '../assets/images/sommerollenD.png';
import sommerollenB from '../assets/images/sommerollenB.png';
import GOIMIEN from '../assets/images/GOIMIEN.png';
import TOMCHIENXU from '../assets/images/TOMCHIENXU.png';
import POMMESMIT from '../assets/images/POMMESMIT.png';
import GAXIEN from '../assets/images/GAXIEN.png';
import TRADITIONALPHOD from '../assets/images/TRADITIONALPHOD.png';
import TRADITIONALPHOB from '../assets/images/TRADITIONALPHOB.png';
import TRADITIONALPHOA from '../assets/images/TRADITIONALPHOA.png';
import GOLDENENUDELNA from '../assets/images/GOLDENENUDELNA.png';
import GOLDENENUDELND from '../assets/images/GOLDENENUDELND.png';
import GOLDENENUDELNB from '../assets/images/GOLDENENUDELNB.png';
import GOLDENENUDELNG from '../assets/images/GOLDENENUDELNG.png';
import BANHCANH from '../assets/images/BANHCANH.png';
import MEERJUNGLADY from '../assets/images/MEERJUNGLADY.png';
import BUNBONAMBO from '../assets/images/BUNBONAMBO.png';
import TOMPIKANTE from '../assets/images/TOMPIKANTE.png';
import BOXAODUA from '../assets/images/BOXAODUA.png';
import HAPPYDAY from '../assets/images/HAPPYDAY.png';
import HELLOCHARGE from '../assets/images/HELLOCHARGE.png';
import HÜHNERHERBSTAG from '../assets/images/HÜHNERHERBSTAG.png';
import VEGANPAPAYA from '../assets/images/VEGANPAPAYA.png';
import SPRINGROLLS from '../assets/images/SPRINGROLLS.png';
import NHATRANGUDON from '../assets/images/NHATRANGUDON.png';
import HACAOTOM from '../assets/images/HACAOTOM.png';
import PADTHAIPHOXAOA from '../assets/images/PADTHAIPHOXAOA.png';
import PADTHAIPHOXAOB from '../assets/images/PADTHAIPHOXAOB.png';
import PADTHAIPHOXAOE from '../assets/images/PADTHAIPHOXAOE.png';
import PADTHAIPHOXAOC from '../assets/images/PADTHAIPHOXAOC.png';
import CURRYLADYA from '../assets/images/CURRYLADYA.png';
import CURRYLADYB from '../assets/images/CURRYLADYB.png';
import CURRYLADYC from '../assets/images/CURRYLADYC.png';
import CURRYLADYD from '../assets/images/CURRYLADYD.png';
import CURRYLADYF from '../assets/images/CURRYLADYF.png';
import CURRYLADYG from '../assets/images/CURRYLADYG.png';
import GELBESCURRYA from '../assets/images/GELBESCURRYA.png';
import GELBESCURRYB from '../assets/images/GELBESCURRYB.png';
import GELBESCURRYC from '../assets/images/GELBESCURRYC.png';
import GELBESCURRYE from '../assets/images/GELBESCURRYE.png';
import GELBESCURRYF from '../assets/images/GELBESCURRYF.png';
import GELBESCURRYG from '../assets/images/GELBESCURRYG.png';
import ERDNUSSSOSSA from '../assets/images/ERDNUSSSOSSA.png';
import ERDNUSSSOSSF from '../assets/images/ERDNUSSSOSSF.png';
import ERDNUSSSOSSB from '../assets/images/ERDNUSSSOSSB.png';
import ERDNUSSSOSSG from '../assets/images/ERDNUSSSOSSG.png';
import MONXAOSAOTA from '../assets/images/MONXAOSAOTA.png';
import MONXAOSAOTD from '../assets/images/MONXAOSAOTD.png';
import MONXAOSAOTF from '../assets/images/MONXAOSAOTF.png';
import MONXAOSAOTG from '../assets/images/MONXAOSAOTG.png';
import MONXAOSAOTC from '../assets/images/MONXAOSAOTC.png';
import GRILLTHEDAYA from '../assets/images/GRILLTHEDAYA.png';
import MONXAOSAOTE from '../assets/images/MON XAOSAOTE.png';
//import U51 from '../assets/images/U51 und13 Aund 14 A.png';
import MONXAOSAOTB from '../assets/images/MONXAOSAOTB.png';
import HÜHNERFLEISCHSPIESSE from '../assets/images/HÜHNERFLEISCHSPIESSE.png';
import COMDAUSESAM from '../assets/images/COMDAUSESAM.png';
import GRILLTHEDAYB from '../assets/images/GRILLTHEDAYB.png';
import GRILLTHEDAYC from '../assets/images/GRILLTHEDAYC.png';
import BUNVIETNAMA from '../assets/images/BUNVIETNAMA.png';
import BUNVIETNAMB from '../assets/images/BUNVIETNAMB.png';
import GELBESCURRYD from '../assets/images/GELBESCURRYD.png';
import BOKHO from '../assets/images/BOKHO.png';
import WanTan from '../assets/images/WanTan.png';
import LimoHonigmelone from '../assets/images/LimoHonigmelone.png';
import fritzkola from '../assets/images/fritz_kola_ClassicLight-.png';
import fritzoriginal from '../assets/images/fritz_cola_orginal.png';
import fitzorange from '../assets/images/fitz-orange.png';
import Superzero from '../assets/images/Superzero.png'
import Bananensalf from '../assets/images/Bananensalf.png';
import GEBRATENERGOLDENERREISA from '../assets/images/GEBRATENERGOLDENERREISA.png';
import GEBRATENERGOLDENERREISB from '../assets/images/GEBRATENERGOLDENERREISB.png';
import GEBRATENERGOLDENERREISF from '../assets/images/GEBRATENERGOLDENERREISF.png';
import UDONXAOD from '../assets/images/UDON XAOD.png';
import UDONXAOE from '../assets/images/UDONXAOE.png';
import UDONXAOB from '../assets/images/UDONXAOB.png';
import GEBRATENERGOLDENERREISG from '../assets/images/GEBRATENERGOLDENERREISG.png';
import UDONXAOG from '../assets/images/UDONXAOG.png';
import UDONXAOF from '../assets/images/UDONXAOF.png';
import UDONXAOA from '../assets/images/UDONXAOA.png';
import SakeMaki from '../assets/images/SakeMaki.png';
import AvocadoMaki from '../assets/images/AvocadoMaki.png';
import SakeAvocadoI from '../assets/images/SakeAvocadoI.png';
import GACHAY from '../assets/images/GACHAY.png';
import BIOTOFUXAO from '../assets/images/BIOTOFUXAO.png';
import RAUXAO from '../assets/images/RAUXAO.png';
import COMXAORAU from '../assets/images/COMXAORAU.png';
import GOLDENEB from '../assets/images/GOLDENEB.png';
import GOLDENEA from '../assets/images/GOLDENEA.png';
import Pommes from '../assets/images/Pommes.png';
import Apfelsaft from '../assets/images/Apfelsaft.png';
import KappaMaki from '../assets/images/KappaMaki.png';
import Litschisaft from '../assets/images/Litschisaft.png';
import Maracujasaft from '../assets/images/Maracujasaft.png';
import Mangosaft from '../assets/images/Mangosaft.png';
import Kirschsalf from '../assets/images/Kirschsalf.png';
import GingerAle from '../assets/images/GingerAle.png';
import Orangensaft from '../assets/images/Orangensaft.png';
import lemonade from '../assets/images/lemonade.png';
import LTCAM from '../assets/images/LTCAM.png';
import ChargeMenü from '../assets/images/ChargeMenü.png';
import MakiMenü from '../assets/images/MakiMenü.png';
import LachsBowl from '../assets/images/LachsBowl.png';
import VeggieBowl from '../assets/images/VeggieBowl.png';
import MitfrischeMango from '../assets/images/MitfrischeMango.png';
import GEBACKENEBANANE from '../assets/images/GEBACKENEBANANE.png';
import EbiTempura from '../assets/images/EbiTempura.png';
import TekkaMaki from '../assets/images/TekkaMaki.png';
import BUNVIETNAMC from '../assets/images/BUNVIETNAMC.png';
import BUNVIETNAME from '../assets/images/BUNVIETNAME.png';
import BUNVIETNAMF from '../assets/images/BUNVIETNAMF.png';
import BUNVIETNAMD from '../assets/images/BUNVIETNAMD.png';
import NHARANGUDON from '../assets/images/NHARANGUDON.png';
import GEBRATENERGOLDENERD from '../assets/images/GEBRATENERGOLDENERD.png';
import SakeAvocado from '../assets/images/SakeAvocado.png';
import EbiSpecialFuto from '../assets/images/EbiSpecialFuto.png';
//import ChickenRoll from '../assets/images/ChickenRoll.png';
import MIENXAOA from '../assets/images/MIENXAOA.png';
import MIENXAOB from '../assets/images/MIENXAOB.png';
import MIENXAOF from '../assets/images/MIENXAOF.png';
import BUNBO from '../assets/images/BUNBO.png';
import SakeAvocadoN from '../assets/images/SAKEAVAOCADON.png';
import Sake from '../assets/images/Sake.png';
import axios from 'axios';
import ColaTurka from '../assets/images/Cola Turka.png';
import UludagGazoz from '../assets/images/UludagGazoz1.png';
import Colazero from '../assets/images/Cola-zero.png';
import Sprite from '../assets/images/Sprite.png';
import limeminze from '../assets/images/limeminze.png';
import MangoOrange from '../assets/images/MangoOrange.png';
import Ananasminze from '../assets/images/Ananasminze.png';
import Mangolassi from '../assets/images/Mangolassi.png';
import lycheejuice from '../assets/images/lycheejuice.png';
import Fanta from '../assets/images/Fanta.png';
import Maracujaschorle from '../assets/images/Maracujaschorle.png';
import DoradoFisch from '../assets/images/DORADOFISH.png';
//import XOINEPRind from '../assets/images/XOINEPRind.png';
//import XOINEPMango from '../assets/images/XOINEPMango.png';
//import XOINEPEIER from '../assets/images/XOINEPEIER.png';
import CaliforniaSpecial from '../assets/images/CaliforniaSpecial.png';
import Inari from '../assets/images/Inari.png';
import Unagi from '../assets/images/Unagi.png';
import PADTHAIPHOXAOF from '../assets/images/PADTHAIPHOXAOF.png';
import PADTHAIPHOXAOG from '../assets/images/PADTHAIPHOXAOG.png';
//import AlaskaRoll5 from '../assets/images/AlaskaRoll5.png';
import Tekka from '../assets/images/Tekka.png';
import Ebi from '../assets/images/Ebi.png';
import PHOSUPPEGARNELEN from '../assets/images/PHOSUPPEGARNELEN.png';
import PAPYASALAT from '../assets/images/8 (2).png';
import TOMYAMGUNG from '../assets/images/TOMYAMGUNG.png';
import MenuFur2 from '../assets/images/Menufur2.png';
import mochCake from '../assets/images/43C.png';
import JASMINREIS from '../assets/images/jasminereis.png';
import REISNUDEL from '../assets/images/reisnudle.png';
import SUSSKARTOFEL from '../assets/images/Suuskartofel.png';
import KIBA from '../assets/images/kiba.png';
import MineralwasserVio from '../assets/images/MineralwasserVio.png';
import COLA from '../assets/images/COLA.png';
import COLALIGHT from '../assets/images/Coca-light.png';
import TonicWater from '../assets/images/TonicWater.png';
import BitteLemon from '../assets/images/BitteLemon.png';
import PANIERTEROLL_A from '../assets/images/PANIERTEROLL_A.png';
import PANIERTEROLL_B from '../assets/images/PANIERTEROLL_B.png';
import SPECIALROLL from '../assets/images/SPECIALROLL.png';
import SPECIALROLLA from '../assets/images/SPECIALROLLA.png';
import SakeSashimi from '../assets/images/SakeSashimi.png';
import TekaSashemi from '../assets/images/TekaSashemi.png';
import SashmeiMix from '../assets/images/SashmeiMix.png';
import SpecialLachsFuto from '../assets/images/SpecialLachsFuto.png';
import TraXanhThaiNguyenTasse from '../assets/images/TraXanhThaiNguyenTasse.png';
import TraHoaNhaiTasse from '../assets/images/TraHoaNhaiTasse.png';
import TraGung from '../assets/images/TraGung.png';
import TrabacHaw from '../assets/images/TrabacHaw.png';
import Kaffee from '../assets/images/Kaffee.png';
import Espresso from '../assets/images/Espresso.png';
import Capuccino from '../assets/images/Capuccino.png';
import LatteMacchiato from '../assets/images/LatteMacchiato.png';
import Milchkaffee from '../assets/images/Milchkaffee.png';
import KaffeeVietnam from '../assets/images/KaffeeVietnam.png';
import CaPheSua from '../assets/images/CaPheSua.png';
import CaPheSuaDa from '../assets/images/CaPheSuaDa.png';
import Avocadosushi from '../assets/images/Avocadosushi.png';
import EbiMaki from '../assets/images/EbiMaki.png';
import CaliforniaMaki from '../assets/images/CaliforniaMaki.png';
import InariMaki from '../assets/images/InariMaki.png';
import CaliforniaSpecialMaki from '../assets/images/CaliforniaSpecialMaki.png';
import TunaMaki from '../assets/images/TunaMaki.png';
import MixBowl from '../assets/images/MixBowl.png';
import GarnelenBowl from '../assets/images/GarnelenBowl.png';
import Tofu from '../assets/images/Tofu.png';
import TeriyakiSake from '../assets/images/TeriyakiSake.png';
import Vegetarische from '../assets/images/Vegetarische.png';
import RucolaKappa from '../assets/images/RucolaKappa.png';
import UnagiI from '../assets/images/UnagiI.png';
import TunaI from '../assets/images/TunaI.png';
import EbiMenü from '../assets/images/EbiMenü.png';
import VeggieMixMenü from '../assets/images/VeggieMixMenü.png';
import LachsMenü from '../assets/images/LachsMenü.png';
import ThunfischMenü from '../assets/images/ThunfischMenü.png';
import TOMCHIENCOM2 from '../assets/images/TOMCHIENCOM2.png';
import PADTHAIPHOXAOD from '../assets/images/PADTHAIPHOXAOD.png';
import ERDNUSSSOSSC from '../assets/images/ERDNUSSSOSSC.png';
import ERDNUSSSOSSE from '../assets/images/ERDNUSSSOSSE.png';
import MIENXAOD from '../assets/images/MIENXAOD.png';
import UDONXAOC from '../assets/images/UDONXAOC.png';
import GEBRATENERGOLDENERREISC from '../assets/images/GEBRATENERGOLDENERREISC.png';
import GEBRATENERGOLDENERREISE from '../assets/images/GEBRATENERGOLDENERREISE.png';
import GEBACKENERAPFEL from '../assets/images/GEBACKENERAPFEL.png';
import MIENXAOG from '../assets/images/MIENXAOG.png';
import MIENXAOC from '../assets/images/MIENXAOC.png';
import MIENXAOE from '../assets/images/MIENXAOE.png';
import KLEBREIS from '../assets/images/KLEBREIS.png';
import GOLDENENUDELNC from '../assets/images/GOLDENENUDELNC.png';
import GOLDENENUDELNE from '../assets/images/GOLDENENUDELNE.png';
import ERDNUSSSOSSD from '../assets/images/ERDNUSSSOSSD.png';
import Uludag_Gazoz_Zero from '../assets/images/Uludag_Gazoz_Zero.png';
import Uludag_Orange from '../assets/images/Uludag_Orange.png';
import Erdnussgross from '../assets/images/Erdnussgross.png';
import Pikantegrosse from '../assets/images/Pikantegrosse.png';
import Currygross from '../assets/images/Currygross.png';
import Erdnessklein from '../assets/images/Erdnessklein.png';
import Curryklein from '../assets/images/Curryklein.png';
import Süßesauer from '../assets/images/Süßesauer.png';
import Coctail from '../assets/images/Coctail.png';
import Unagie from '../assets/images/Unagie.png';
import BOSALAT from '../assets/images/BOSALAT.png';
import GinyyGinger from '../assets/images/Ginny_Ginger.png';
import TropicalBeach from '../assets/images/Tropical_Beach.png';
import VeryBerry from '../assets/images/Very_Berry.png';
import PeachOrange from '../assets/images/Peach_Orange.png';
import LycheeLemonade from '../assets/images/Lychee_Lemonade.png';
import WANTANCHIEN from '../assets/images/WANTAN_CHIEN.png';
import SESAMBÄLLCHEN from '../assets/images/SESAMBÄLLCHEN.png';
import FRUCHTMIX from '../assets/images/FRUCHT-MIX.png';
import TOM_CHIEN_COM from '../assets/images/TOM CHIEN COM.png';
import ERDNÜSSE from '../assets/images/ERDNÜSSE.png';
import MultiVitamin from '../assets/images/MultiVitamin.png';
import Pfirsich from '../assets/images/Pfirsich.png';
import Zitrone from '../assets/images/Zitrone.png';


// ✅ Added: helper to convert "13,90 €" → 13.90
const parsePrice = (priceString) => {
    if (typeof priceString === 'string') {
        const cleaned = priceString.replace('€', '').trim().replace(',', '.');
        return parseFloat(cleaned);
    }
    return priceString;
};

export const initialMenuItems = [

    {
        id: 1,
        code: 'M1',
        title: 'Maki Menü (B,F)',
        description: '6 stk Maki Sake, 6 Stk Maki Tekka, 6 stk Maki Avocado',
        price: '14,50€',
        category: 'sushi-menüs',
        subcategory: 'sushi-menüs',
        image: MakiMenü
    },

    {
        id: 2,
        code: '141',
        title: 'Veggie Bowl (A,D,I,F,M)',
        description: '5 Stk gebackener Tofu, 2 Stk Avocado, Duftreis, frischen Salat, gekochtem Gemüse und hausgemachten Soßen, Sesam',
        price: '14,90 €',
        category: 'sushi-menüs',
        subcategory: 'chef-poke-bowl',
        image: VeggieBowl
    },
    {
        id: 3,
        code: '142',
        title: 'Alaska Roll (A,B,D,F,I,M)',
        description: 'Lachs, Avocado, Gurke, Frischkäse, Lauch und Soße mit A. 5 STK B. 10 STK',
        price: '8,50€',
        category: 'sushi-menüs',
        subcategory: 'panierte-roll',
        image: PANIERTEROLL_B,
        variants: {
            A: {
                title: 'Alaska Roll (A,B,D,F,I,M)',
                description: '5 STK',
                price: '8,50€',
                image: PANIERTEROLL_A,
            },
            B: {

                title: 'Alaska Roll (A,B,D,F,I,M) ',
                description: '10 STK',
                price: ' 14,50€',
                image: PANIERTEROLL_B,
            },
        },
    },


    {
        id: 4,
        code: '80',
        title: 'Sake (B)',
        description: 'Lachs - salmon',
        price: '6,00 €',
        category: 'sushi-menüs',
        subcategory: 'nigiri',
        image: Sake
    },
    {
        id: 5,
        code: '81',
        title: 'Tekka (B)',
        description: 'Thunfisch - tuna',
        price: '6,50 €',
        category: 'sushi-menüs',
        subcategory: 'nigiri',
        image: Tekka
    },
    {
        id: 6,
        code: '82',
        title: 'Ebi (C)',
        description: 'Garnelen - shrimps',
        price: '6,50 €',
        category: 'sushi-menüs',
        subcategory: 'nigiri',
        image: Ebi
    },
    {
        id: 7,
        code: '83',
        title: 'Sake Avocado',
        price: '6,50 €',
        category: 'sushi-menüs',
        subcategory: 'nigiri',
        image: SakeAvocadoN
    },
    {
        id: 8,
        code: '84',
        title: ' Avocado',
        price: '5,50 €',
        category: 'sushi-menüs',
        subcategory: 'nigiri',
        image: Avocadosushi
    },
    {
        id: 9,
        code: '85',
        title: 'Inari (M) ',
        description: 'Tofu',
        price: '5,50 €',
        category: 'sushi-menüs',
        subcategory: 'nigiri',
        image: Inari
    },
    {
        id: 10,
        code: '86',
        title: 'Unagi (B)',
        description: 'Aal - eel',
        price: '6,50 €',
        category: 'sushi-menüs',
        subcategory: 'nigiri',
        image: Unagi
    },
    {
        id: 11,
        code: '87',
        title: 'California Special (A,C)',
        description: 'Echtes Krebsfleisch, Mayonnaise & Lauch',
        price: '6,50 €',
        category: 'sushi-menüs',
        subcategory: 'nigiri',
        image: CaliforniaSpecial
    },
    {
        id: 12,
        code: '1',
        title: 'Sommerrollen (A,B,E,M)',
        description: '2 frische Sommerollen aus Reispapier, Salat, Resinudeln & Kräutern mit Soße. Gefüllt mit A. Hühn B. Garnelen C. Tofu D. Gegrillte Lachs',
        price: '5,90 €',
        category: 'vorspeisen',
        image: sommerollenA,
        variants: {
            A: {
                title: 'Sommerrollen - Hühn',
                description: 'Gefüllt mit Hühn',
                price: '5,90 €',
                image: sommerollenA, // replace with actual Hühn image
            },
            B: {
                title: 'Sommerrollen - Garnelen (B,H)',
                description: 'Gefüllt mit Garnelen',
                price: '5,90 €',
                image: sommerollenB, // replace with Garnelen image
            },
            C: {
                title: 'Sommerrollen - Natur Tofu',
                description: 'Gefüllt mit Tofu',
                price: '5,90 €',
                image: sommerollenC, // replace with Tofu image
            },
            D: {
                title: 'Sommerrollen - Gegrillte Lachs(D)',
                description: 'Gefüllt mit Gegrillte Lachs',
                price: '7,90 €',
                image: sommerollenD, // replace with Lachs image
            },
        },
    },
    {
        id: 13,
        code: 'U13',
        title: 'BANH CANH (NEU) (A,B,D)',
        description: 'Große Schale Udonsuppe, mit Hausgemachte Lachs Fischbällchen u. Garnelen',
        price: '16,90€',
        category: 'empfehlung',
        image: BANHCANH
    },
    {
        id: 14,
        code: 'U14',
        title: 'XOI NEP (NEU)(M,E)',
        description: 'Gedämpfter Klebreis mit Kokosmilch, Salat, Gurke, Röstzwiebeln. Gefüllt mit A. Rind B. Mango C. Eier ',
        price: '13,90€',
        category: 'empfehlung',
        variants: {
            A: {
                title: 'XOI NEP - Rind',
                description: 'Gefüllt mit Rind',
                price: '13,90€',
            },
            B: {
                title: 'XOI NEP - Mango',
                description: 'Gefüllt mit Mango',
                price: '12,90 €',
            },
            C: {
                title: 'XOI NEP - OMLET - EIER',
                description: 'Gefüllt mit Eier',
                price: '12,90 €',
            },

        },
    },
    {
        id: 15,
        code: 'U16',
        title: 'BO XAO DUA (NEU) (A,N,M)',
        description: 'Gebratenes Rindfleisch mit Ananas,Zwiebeln, Breite Bohnen, Porree,Knoblauch in Hausgemachtes Soße (Scharf)',
        price: '14,90€',
        category: 'empfehlung',
        image: BOXAODUA
    },
    {
        id: 16,
        code: 'U17',
        title: 'LAU THAP CAM  (NEU)',
        description: 'Eintopf mit Meeresfrüchten mit Fischbällchen, Rinderbällchen, Garnelen, Rindfleisch und Vers. Gemüse Serviert mit Reisnudeln . A. 2 Personen ab 45.90€. B. ab 4 Personen auf Anfrage',
        price: '45,90€',
        category: 'empfehlung',
        image: LTCAM

    },
    {
        id: 17,
        code: 'U18',
        title: 'Dorade Fisch(A,B,E)',
        description: ' gegrilltes Dorade Fisch, Tomaten Sauce mit Ananas frischem Salat, Kräutern, und Limetten- Dressing Marinated Serviert mit Jasminreis',
        price: '19,90€',
        category: 'empfehlung',
        image: DoradoFisch
    },

    {
        id: 18,
        code: 'U19',
        title: 'NHA TRANG UDON (B,D,C)',
        description: 'Große Schale Udonsuppe, mit Fischbällchen u. Garnelen.',
        price: '14,90€',
        category: 'empfehlung',
        image: NHATRANGUDON
    },
    {
        id: 19,
        code: 'U20',
        title: 'BUN BO NAM BO (N,E)',
        description: 'Gebratenes Rindfleisch mit Zitronengras, Zwiebeln auf Reisnudeln.',
        price: '13,90€',
        category: 'empfehlung',
        image: BUNBONAMBO
    },
    {
        id: 20,
        code: 'U21',
        title: 'MEERJUNG LADY (A,B,G,H)',
        description: 'Gebackene große Garnelen auf rotem Curry Creme Kokosnuss. Serviert mit Jasminreis.',
        price: '15,90€',
        category: 'empfehlung',
        image: MEERJUNGLADY
    },
    {
        id: 21,
        code: 'U22',
        title: 'TOM PIKANTE (A,H,B)',
        description: 'Pikante Sauce mit Ver. Gemüse, gebackene große Garnelen mit Jasmin Reis.',
        price: '15,90€',
        category: 'empfehlung',
        image: TOMPIKANTE
    },
    {
        id: 22,
        code: 'U50',
        title: 'HAPPY DAY (A,E,G)',
        description: 'Knusprige Ente, Papaya-Salat mit cremiger Erdnusssoße.  Serviert mit Jasminreis oder Süßkartoffelstreifen.',
        price: '16,90€',
        category: 'empfehlung',
        image: HAPPYDAY
    },
    {
        id: 23,
        code: 'U51',
        title: 'HELLO CHARGE ENTE SPECIAL(A,E,G)',
        description: 'Knusprige Ente mit rotem Curry, cremig. Serviert mit Jasmin Reis.',
        price: '15,90€',
        category: 'empfehlung',
        image: HELLOCHARGE
    },
    {
        id: 24,
        code: 'U52',
        title: 'HÜHNER HERBSTAG (A,N)',
        description: 'Hähnchenbrust gebacken auf Masaman Curry, cremig. Serviert mit Jasmin Reis.',
        price: '13,90€',
        category: 'empfehlung',
        image: HÜHNERHERBSTAG
    },
    {
        id: 25,
        code: 'U53',
        title: 'VEGAN PAPAYA (E,A,G)',
        description: 'Würziger, grüner Papayasalat in einer mit Kokosmilch-Erdnusssoße (scharf). Serviert mit Jasminreis oder Süßkartoffelstreifen.',
        price: '13,90€',
        category: 'empfehlung',
        image: VEGANPAPAYA
    },
    {
        id: 26,
        code: 'U15',
        title: 'BO KHO (NEU)',
        description: 'in Geschmortes Rind Würfel, Knoblauch, Zitronengras, Kartoffeln, Karroten, Serviert mit Jasminreis oder Reisnudeln',
        price: '14,90€',
        category: 'empfehlung',
        image: BOKHO
    },

    {
        id: 27,
        code: '2',
        title: 'SPRING ROLLS (A,B,M)',
        description: 'Knusprige Frühlingsrollen gefüllt mit Garnelen, Hühnerfleisch und Glasnudeln.',
        price: '5,90€',
        category: 'vorspeisen',
        image: SPRINGROLLS
    },
    {
        id: 28,
        code: '3',
        title: '3 HÜHNERFLEISCHSPIESSE (E,A)',
        description: 'Erdnussoße, Salat.',
        price: '6,90€',
        category: 'vorspeisen',
        image: HÜHNERFLEISCHSPIESSE
    },
    {
        id: 29,
        code: '4',
        title: 'TOM CHIEN XU (2 STK.)(A,B)',
        description: 'Gebackene Garnelen, Salat',
        price: '7,90€',
        category: 'vorspeisen',
        image: TOMCHIENXU
    },
    {
        id: 30,
        code: '4A',
        title: 'TOM CHIEN COM (2 STK.)(A,B)',
        description: 'gebackene Großgarnelen,paniert mit getrocknetem zerstossenem Klebreis.Serviert mit Salat und lieblicher Unagi-Soße.',
        price: '8,90€',
        category: 'vorspeisen',
        image: TOM_CHIEN_COM
    },
    {
        id: 31,
        code: '5',
        title: 'PAPAYA SALAT(B,E)',
        description: 'Mit frischen, grünen Papayas und Salat,Limetten-Palmzucker -Dressing (scharf).',
        price: '9,90€',
        category: 'vorspeisen',
        image: PAPYASALAT
    },
    {
        id: 32,
        code: '6',
        title: ' BO SALATE(E)',
        description: 'Mit gebratenem Rindfleisch, Zitronengras, Salat, Thai-Basilikum, Erdnuss',
        price: '9,90€',
        category: 'vorspeisen',
        image: BOSALAT,
    },
    {
        id: 33,
        code: '6A',
        title: ' Mit frische Mango (E)',
        description: 'Mit gebratenem Rindfleisch, Zitronengras, Salat, Thai-Basiliku, Erdnuss',
        price: '10,90€',
        category: 'vorspeisen',
        image: MitfrischeMango,
    },
    {
        id: 34,
        code: '7',
        title: ' GOI MIEN(E,C)',
        description: 'Mit gemischtem Salat im Wok geschwenktem Tofu, Glasnudeln, Koriander und Chili.',
        price: '8,90€',
        category: 'vorspeisen',
        image: GOIMIEN
    },
    {
        id: 35,
        code: '8',
        title: ' WAN TAN SUPPE (A,B)',
        description: 'Mit Garnelen & Hühnerfleischfüllung. Gemüse.',
        price: '5,90€',
        category: 'suppen',
        image: WanTan
    },
    {
        id: 36,
        code: '9',
        title: 'TOM KHA GAI(M,G)',
        description: 'Kokosmilch-Suppe mit Zitronengras und Hühnerfleisch, Gemüse. Gefüllt mit A.Hühn B.Garnelen C.Tofu',
        price: '5,90€',
        category: 'suppen',
        image: somC,
        variants: {
            A: {
                title: 'TOM KHA GAI - Hühn',
                description: 'Gefüllt mit Hühn',
                price: '5,90€',
                image: somC, // replace with actual Hühn image
            },
            B: {
                title: 'TOM KHA GAI - Garnelen',
                description: 'Gefüllt mit Garnelen',
                price: '5,90 €',
                image: TVGsupppe, // replace with Garnelen image
            },
            C: {
                title: 'TOM KHA GAI - Tofu',
                description: 'Gefüllt mit Tofu',
                price: '5,90 €',
                image: somC, // replace with Tofu image
            },

        },
    },
    {
        id: 37,
        code: '10',
        title: 'TOM YAM GUNG (SCHARF)(B)',
        description: 'Garnelen-Suppe mit Zitronengras und Gemüse. Gefüllt mit A.Hühn B.Garnelen C.Tofu',
        price: '5,90€',
        category: 'suppen',
        image: TOMYAMGUNG,
        variants: {
            A: {
                title: 'TOM YAM GUNG (SCHARF) - Hühn',
                description: 'Gefüllt mit Hühn',
                price: '5,90€',
                image: TOMYAMGUNG, // replace with actual Hühn image
            },
            B: {
                title: 'TOM YAM GUNG (SCHARF) - Garnelen',
                description: 'Gefüllt mit Garnelen',
                price: '5,90 €',
                image: TOMYAMGUNG, // replace with Garnelen image
            },
            C: {
                title: 'TOM YAM GUNG (SCHARF) - Tofu',
                description: 'Gefüllt mit Tofu',
                price: '5,90 €',
                image: TOMYAMGUNG, // replace with Tofu image
            },

        },
    },
    {
        id: 38,
        code: '39A',
        title: ' HA CAO TOM 4 STK.(A,B,F)',
        description: 'Gedämpfte Dimsum mit Garnelenfüllung und mit Soße überzogen.',
        price: '6,90€',
        category: 'tapas',
        image: HACAOTOM
    },
    {
        id: 39,
        code: '39B',
        title: '  HA CAO CHAY 5 STK(F,A)',
        description: ' Gedämpfte Knödel gefüllt mit Gemüse, Sojabohnen und mit Soße überzogen.',
        price: '5,90€',
        category: 'tapas',
        image: HACAOTOM
    },
    {
        id: 40,
        code: '39C',
        title: 'MINI FRÜHLINGSROLLEN (VEGAN) 8 STK.(A)',
        description: ' Knusprige Frühlingsrollen gefüllt mit Gemüseund Glasnudeln, serviert mit süßer Soße.',
        price: '5,90€',
        category: 'tapas',
        image: MINIFVEGAN
    },
    {
        id: 41,
        code: '39D',
        title: ' EDAMAME(F)',
        description: ' Gedämpfte japanische Sojabohnen.',
        price: '5,90€',
        category: 'tapas',
        image: EDAMAME
    },
    {
        id: 178,
        code: '39E',
        title: ' WANTAN CHIEN 3 STK(F)',
        description: ' Gebackene Teigtaschen mit Hähnchen, Garnelen und exotischer Süß-Chili Sauce.',
        price: '5,90€',
        category: 'tapas',
        image: WANTANCHIEN
    },
    {
        id: 179,
        code: '39F',
        title: ' ERDNÜSSE(F)',
        description: ' Vietnamesische gekochte Erdnüsse.',
        price: '5,90€',
        category: 'tapas',
        image: ERDNÜSSE
    },
    {
        id: 42,
        code: '11',
        title: 'TRADITIONAL PHO (F)',
        description: 'Reisbandnudelsuppe mit Koriander, Zwiebeln.. Gefüllt mit A. Hühn B. Rind C. Garnelen D. Tofu',
        price: '12,90 €',
        category: 'main',
        image: TRADITIONALPHOA,
        variants: {
            A: {
                title: 'TRADITIONAL PHO - HÜHNERFLEISCH',
                description: 'Gefüllt mit Hühn',
                price: '12,90 €',
                image: TRADITIONALPHOA, // replace with actual Hühn image
            },
            B: {
                title: 'TRADITIONAL PHO - RINDFLEISCH',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: TRADITIONALPHOB, // replace with Garnelen image
            },
            C: {
                title: 'TRADITIONAL PHO - GARNELEN (B)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: PHOSUPPEGARNELEN, // replace with Tofu image
            },
            D: {
                title: 'TRADITIONAL PHO - Natur TOFU',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: TRADITIONALPHOD, // replace with Lachs image
            },
        },
    },
    {
        id: 43,
        code: '12',
        title: 'PAD THAI PHO XAO (A,C,E)',
        description: 'Im Wok angebratene Reisbandnudeln mit Gemüse und Kräutern. Gefüllt mit A. Entenfilets B. Hühn C. Garnelen D. Rind E.Tofu F.Hühnchenbrust G.Große Garnelen',
        price: '15,90 €',
        category: 'main',
        image: PADTHAIPHOXAOA,
        variants: {
            A: {
                title: 'PAD THAI PHO XAO - KNUSPRIGE ENTENFILETS(A)',
                description: 'Gefüllt mit Entenfilets',
                price: '15,90 €',
                image: PADTHAIPHOXAOA, // replace with actual Hühn image
            },
            B: {
                title: 'PAD THAI PHO XAO- HÜHNERFILETS',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
                image: PADTHAIPHOXAOB, // replace with Garnelen image
            },
            C: {
                title: 'PAD THAI PHO XAO - GARNELEN (B)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: PADTHAIPHOXAOC, // replace with Tofu image
            },
            D: {
                title: 'PAD THAI PHO XAO - RINDFLEISCH(F)',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: PADTHAIPHOXAOD,
            },
            E: {
                title: 'PAD THAI PHO XAO - Natur TOFU(F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: PADTHAIPHOXAOE, // replace with Lachs image
            },
            F: {
                title: 'PAD THAI PHO XAO - PANIERTE HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit Hühnchenbrust',
                price: '13,90 €',
                image: PADTHAIPHOXAOF, // replace with Lachs image
            },
            G: {
                title: 'PAD THAI PHO XAO - PANIERTE GROßE GARNELEN(A,B)',
                description: 'Gefüllt mit Große Garnelen',
                price: '15,90 €',
                image: PADTHAIPHOXAOG, // replace with Lachs image
            },
        },
    },
    {
        id: 44,
        code: '13',
        title: 'CURRY LADY (G)',
        description: 'In roter Curry, cremig, Kokosnuss - milch, Gemüse. Serviert mit Jasminreis. Gefüllt mit A. Entenfilets B. Hühn C. Garnelen D. Rind E.Tofu F.Hühnchenbrust G.Große Garnelen ',
        price: '15,90 €',
        category: 'main',
        image: CURRYLADYA,
        variants: {
            A: {
                title: 'CURRY LADY - KNUSPRIGE ENTENFILETS(A,E,G)',
                description: 'Gefüllt mit Entenfilets',
                price: '15,90 €',
                image: CURRYLADYA, // replace with actual Hühn image
            },
            B: {
                title: 'CURRY LADY- HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
                image: CURRYLADYB, // replace with Garnelen image
            },
            C: {
                title: 'CURRY LADY - GARNELEN (B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: CURRYLADYC, // replace with Tofu image
            },
            D: {
                title: 'CURRY LADY - RINDFLEISCH',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: CURRYLADYD, // replace with Lachs image
            },
            E: {
                title: 'CURRY LADY - Natur TOFU (F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: menuImage, // replace with Lachs image
            },
            F: {
                title: 'CURRY LADY - PANIERTE HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit Hühnchenbrust',
                price: '13,90 €',
                image: CURRYLADYF, // replace with Lachs image
            },
            G: {
                title: 'CURRY LADY - PANIERTE GROßE GARNELEN(A,B)',
                description: 'Gefüllt mit Große Garnelen',
                price: '15,90 €',
                image: CURRYLADYG, // replace with Lachs image
            },
        },
    },
    {
        id: 45,
        code: '14',
        title: 'MASAMA CURRY (G)',
        description: 'In Masaman Curry, cremig, Kokosnuss - milch Gemüse. Serviert mit Jasmin- reis. Gefüllt mit A. Entenfilets B. Hühn C. Garnelen D. Rind E.Tofu F.Hühnchenbrust G.Große Garnelen ',
        price: '15,90 €',
        category: 'main',
        image: CURRYLADYA,
        variants: {
            A: {
                title: 'MASAMAN CURRY - KNUSPRIGE ENTENFILETS(A,E,G)',
                description: 'Gefüllt mit Entenfilets',
                price: '15,90 €',
                image: CURRYLADYA, // replace with actual Hühn image
            },
            B: {
                title: 'MASAMAN CURRY- HÜHNERFILETSG(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
                image: CURRYLADYB, // replace with Garnelen image
            },
            C: {
                title: 'MASAMAN CURRY - GARNELEN (B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: CURRYLADYC, // replace with Tofu image
            },
            D: {
                title: 'MASAMAN CURRY - RINDFLEISCH',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: CURRYLADYD, // replace with Lachs image
            },
            E: {
                title: 'MASAMAN CURRY - Natur TOFU(F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: menuImage, // replace with Lachs image
            },
            F: {
                title: 'MASAMAN CURRY - PANIERTE HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit Hühnchenbrust',
                price: '13,90 €',
                image: CURRYLADYF, // replace with Lachs image
            },
            G: {
                title: 'MASAMAN CURRY - PANIERTE GROßE GARNELEN(A,B)',
                description: 'Gefüllt mit Große Garnelen',
                price: '15,90 €',
                image: CURRYLADYG, // replace with Lachs image
            },
        },
    },
    {
        id: 46,
        code: '15',
        title: 'GELBES CURRY (A,G)',
        description: 'In gelber Curry, cremig, Kokosnuss, Gemüse. Serviert mit Jasminreis. Gefüllt mit A. Entenfilets B. Hühn C. Garnelen D. Rind E. Tofu F. Hühnchenbrust G. Große Garnelen ',
        price: '15,90 €',
        category: 'main',
        image: GELBESCURRYA,
        variants: {
            A: {
                title: 'GELBES CURRY - KNUSPRIGE ENTENFILETS(A,E,G)',
                description: 'Gefüllt mit Entenfilets',
                price: '15,90 €',
                image: GELBESCURRYA, // replace with actual Hühn image
            },
            B: {
                title: 'GELBES CURRY- HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
                image: GELBESCURRYB, // replace with Garnelen image
            },
            C: {
                title: 'GELBES CURRY - GARNELEN(B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: GELBESCURRYC, // replace with Tofu image
            },
            D: {
                title: 'GELBES CURRY - RINDFLEISCH',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: GELBESCURRYD, // replace with Lachs image
            },
            E: {
                title: 'GELBES CURRY - Natur TOFU (F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: GELBESCURRYE, // replace with Lachs image
            },
            F: {
                title: 'GELBES CURRY - PANIERTE HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit Hühnchenbrust',
                price: '13,90 €',
                image: GELBESCURRYF, // replace with Lachs image
            },
            G: {
                title: 'GELBES CURRY - PANIERTE GROßE GARNELEN(A,B)',
                description: 'Gefüllt mit Große Garnelen',
                price: '15,90 €',
                image: GELBESCURRYG, // replace with Lachs image
            },
        },
    },
    {
        id: 47,
        code: '16',
        title: 'ERDNUSSSOSS (A,E,G)',
        description: 'Mit cremiger Kokosnuss, Gemüse, serviert mit Jasminreis. Gefüllt mit A. Entenfilets B. Hühn C. Garnelen D. Rind E.Tofu F.Hühnchenbrust G.Große Garnelen ',
        price: '15,90 €',
        category: 'main',
        image: ERDNUSSSOSSA,
        variants: {
            A: {
                title: 'ERDNUSSSOSS - KNUSPRIGE ENTENFILETS(A,E,G)',
                description: 'Gefüllt mit Entenfilets',
                price: '15,90 €',
                image: ERDNUSSSOSSA, // replace with actual Hühn image
            },
            B: {
                title: 'ERDNUSSSOSS- HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
                image: ERDNUSSSOSSB, // replace with Garnelen image
            },
            C: {
                title: 'ERDNUSSSOSS - GARNELEN(B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: ERDNUSSSOSSC,

            },
            D: {
                title: 'ERDNUSSSOSS - RINDFLEISCH',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: ERDNUSSSOSSD,
            },
            E: {
                title: 'ERDNUSSSOSS - Natur TOFU(F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: ERDNUSSSOSSE,
            },
            F: {
                title: 'ERDNUSSSOSS - PANIERTE HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit Hühnchenbrust',
                price: '13,90 €',
                image: ERDNUSSSOSSF // replace with Lachs image
            },
            G: {
                title: 'ERDNUSSSOSS - PANIERTE GROßE GARNELEN(A,B)',
                description: 'Gefüllt mit Große Garnelen',
                price: '15,90 €',
                image: ERDNUSSSOSSG, // replace with Lachs image
            },
        },
    },
    {
        id: 48,
        code: '17',
        title: 'MON XAO SA OT(F)',
        description: 'Gebratenes Gemüse, Kaiserschoten, Zitronengras und Knoblauch, Sojasprossen, Chili (scharf). Serviert mit Jasminreis. Gefüllt mit A. Entenfilets B. Hühn C. Garnelen D. Rind E.Tofu F.Hühnchenbrust G.Große Garnelen ',
        price: '15,90 €',
        category: 'main',
        image: MONXAOSAOTA,
        variants: {
            A: {
                title: 'MON XAO SA OT - KNUSPRIGE ENTENFILETS(A,E,G)',
                description: 'Gefüllt mit Entenfilets',
                price: '15,90 €',
                image: MONXAOSAOTA // replace with actual Hühn image
            },
            B: {
                title: 'MON XAO SA OT- HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
                image: MONXAOSAOTB, // replace with Garnelen image
            },
            C: {
                title: 'MON XAO SA OT - GARNELEN(B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: MONXAOSAOTC, // replace with Tofu image
            },
            D: {
                title: 'MON XAO SA OT - RINDFLEISCH',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: MONXAOSAOTD, // replace with Lachs image
            },
            E: {
                title: 'MON XAO SA OT - Natur TOFU (F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: MONXAOSAOTE, // replace with Lachs image
            },
            F: {
                title: 'MON XAO SA OT - PANIERTE HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit Hühnchenbrust',
                price: '13,90 €',
                image: MONXAOSAOTF, // replace with Lachs image
            },
            G: {
                title: 'MON XAO SA OT - PANIERTE GROßE GARNELEN(A,B)',
                description: 'Gefüllt mit Große Garnelen',
                price: '15,90 €',
                image: MONXAOSAOTG, // replace with Lachs image
            },
        },
    },

    {
        id: 49,
        code: '18',
        title: 'GRILL THE DAY(D,F,A)',
        description: 'In dunkler, hausgemachter Soße mit vers. Gemüse, serviert mit Jasminreis oder Süßkartoffelstreifen (leicht scharf) Gefüllt mit A. Rind B. Lachs C.Große Garnelen ',
        price: '19,90 €',
        category: 'main',
        image: GRILLTHEDAYA,
        variants: {
            A: {
                title: 'GRILL THE DAY - RINDERSTEAK',
                description: 'Gefüllt mit Rind',
                price: '19,90 €',
                image: GRILLTHEDAYA, // replace with actual Hühn image
            },
            B: {
                title: 'GRILL THE DAY- GEGRILLTE LACHS(D)',
                description: 'Gefüllt mit Lachs',
                price: '19,90 €',
                image: GRILLTHEDAYB, // replace with Garnelen image
            },
            C: {
                title: 'GRILL THE DAY - GEGRILLTE GROßGARNELEN(A,B)',
                description: 'Gefüllt mit Garnelen',
                price: '19,90 €',
                image: GRILLTHEDAYC, // replace with Tofu image
            },
            D: {
                title: 'GRILL THE DAY - GEGRILL TE HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit HÄHNCHENBRUST',
                price: '16,90 €',
                image: GRILLTHEDAYC, // replace with Tofu image
            },



        },
    },
    {
        id: 50,
        code: '19',
        title: 'NHA TRANG UDON(A,B,D)',
        description: 'Große Schale Udonsuppe in spezieller Brühe, mit Gemüse, Fischbällchen und Garnelen.',
        price: '14,90€',
        category: 'main',
        image: NHARANGUDON
    },
    {
        id: 51,
        code: '20',
        title: 'BUN BO NAM BO(E)',
        description: 'Gebratenies Rindfleisch mit . Zitronengras, Zwiebeln auf Reisnudeln, Chili und Limetten.',
        price: '13,90€',
        category: 'main',
        image: BUNBO
    },
    {
        id: 52,
        code: '21',
        title: 'GOLDENE NUDELN(A,F)',
        description: 'Gebratene Nudeln mit vers. Gemüse, Eiern, Möhren, Sojasprossen. Gefüllt mit A. Entenfilets B. Hühn C. Garnelen D. Rind E.Tofu F.Hühnchenbrust G.Große Garnelen ',
        price: '15,90 €',
        category: 'main',
        image: GOLDENENUDELNA,
        variants: {
            A: {
                title: 'GOLDENE NUDELN - KNUSPRIGE ENTENFILETS(A,E,G)',
                description: 'Gefüllt mit Entenfilets',
                price: '15,90 €',
                image: GOLDENENUDELNA, // replace with actual Hühn image
            },
            B: {
                title: 'GOLDENE NUDELN- HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
                image: GOLDENENUDELNB, // replace with Garnelen image
            },
            C: {
                title: 'GOLDENE NUDELN - GARNELEN(B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: GOLDENENUDELNC,
            },
            D: {
                title: 'GOLDENE NUDELN - RINDFLEISCH',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: GOLDENENUDELND, // replace with Lachs image
            },
            E: {
                title: 'GOLDENE NUDELN- Natur TOFU(F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: GOLDENENUDELNE,
            },
            F: {
                title: 'GOLDENE NUDELN - PANIERTE HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit Hühnchenbrust',
                price: '13,90 €',
                image: GOLDENEB, // replace with Lachs image
            },
            G: {
                title: 'GOLDENE NUDELN - PANIERTE GROßE GARNELEN(A,B)',
                description: 'Gefüllt mit Große Garnelen',
                price: '15,90 €',
                image: GOLDENENUDELNG, // replace with Lachs image
            },
        },
    },
    {
        id: 53,
        code: '22',
        title: 'GEBRATENER GOLDENER REIS(A,F)',
        description: 'gebratener Reis mit vers. Gemüse, Erbsen, Eiern,Möhren, Sojasprossen. Gefüllt mit A. Entenfilets B. Hühn C. Garnelen D. Rind E.Tofu F.Hühnchenbrust G.Große Garnelen ',
        price: '15,90 €',
        category: 'main',
        image: GEBRATENERGOLDENERREISA,
        variants: {
            A: {
                title: 'GEBRATENER GOLDENER REIS - KNUSPRIGE ENTENFILETS(A,E,G)',
                description: 'Gefüllt mit Entenfilets',
                price: '15,90 €',
                image: GEBRATENERGOLDENERREISA, // replace with actual Hühn image
            },
            B: {
                title: 'GEBRATENER GOLDENER REIS- HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
                image: GEBRATENERGOLDENERREISB, // replace with Garnelen image
            },
            C: {
                title: 'GEBRATENER GOLDENER REIS - GARNELEN(B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: GEBRATENERGOLDENERREISC,
            },
            D: {
                title: 'GEBRATENER GOLDENER REIS - RINDFLEISCH',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: GEBRATENERGOLDENERD, // replace with Lachs image
            },
            E: {
                title: 'GEBRATENER GOLDENER REIS- Natur TOFU(F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: GEBRATENERGOLDENERREISE,
            },
            F: {
                title: 'GEBRATENER GOLDENER REIS - PANIERTE HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit Hühnchenbrust',
                price: '13,90 €',
                image: GEBRATENERGOLDENERREISF, // replace with Lachs image
            },
            G: {
                title: 'GEBRATENER GOLDENER REIS - PANIERTE GROßE GARNELEN(A,B)',
                description: 'Gefüllt mit Große Garnelen',
                price: '15,90 €',
                image: GEBRATENERGOLDENERREISG, // replace with Lachs image
            },
        },
    },
    {
        id: 54,
        code: '30',
        title: 'XAO PIKANTE SOßE(A,B,F)',
        description: 'In dunkler, hausgemachter Soße mit vers. Gemüse, serviert mit Jasminreis (leicht scharf) Gefüllt mit A. Entenfilets B. Hühn C. Garnelen D. Rind E.Tofu F.Hühnchenbrust G.Große Garnelen ',
        price: '15,90 €',
        category: 'main',
        image: MONXAOSAOTA,
        variants: {
            A: {
                title: 'XAO PIKANTE SOßE - KNUSPRIGE ENTENFILETS(A,E,G)',
                description: 'Gefüllt mit Entenfilets',
                price: '15,90 €',
                image: MONXAOSAOTA, // replace with actual Hühn image
            },
            B: {
                title: 'XAO PIKANTE SOßE- HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
                image: MONXAOSAOTB, // replace with Garnelen image
            },
            C: {
                title: 'XAO PIKANTE SOßE - GARNELEN(B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: MONXAOSAOTC, // replace with Tofu image
            },
            D: {
                title: 'XAO PIKANTE SOßE - RINDFLEISCH',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: MONXAOSAOTD, // replace with Lachs image
            },
            E: {
                title: 'XAO PIKANTE SOßE- Natur TOFU(F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: MONXAOSAOTE, // replace with Lachs image
            },
            F: {
                title: 'XAO PIKANTE SOßE - PANIERTE HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit Hühnchenbrust',
                price: '13,90 €',
                image: MONXAOSAOTF, // replace with Lachs image
            },
            G: {
                title: 'XAO PIKANTE SOßE - PANIERTE GROßE GARNELEN(A,B)',
                description: 'Gefüllt mit Große Garnelen',
                price: '15,90 €',
                image: MONXAOSAOTG, // replace with Lachs image
            },
        },
    },
    {
        id: 55,
        code: '40',
        title: 'BUN VIETNAM (F)',
        description: 'Reisnudelsuppe mit Koriander, Zwiebeln, Tomaten Gefüllt mit A. Hühn  B. Rind C. Garnelen D.Tofu E.Lachs F.Lachs Ball ',
        price: '11,90 €',
        category: 'main',
        image: BUNVIETNAMA,
        variants: {
            A: {
                title: 'BUN VIETNAM - HÜHNERFILETS',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
                image: BUNVIETNAMA, // replace with actual Hühn image
            },
            B: {
                title: 'BUN VIETNAM- RINDFLEISCH',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: BUNVIETNAMB, // replace with Garnelen image
            },
            C: {
                title: 'BUN VIETNAM - GARNELEN (B)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: BUNVIETNAMC, // replace with Tofu image
            },
            D: {
                title: 'BUN VIETNAM- Natur TOFU(F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: BUNVIETNAMD, // replace with Lachs image
            },
            E: {
                title: 'BUN VIETNAM - LACHSFILET(D)',
                description: 'Gefüllt mit Lachs',
                price: '15,90 €',
                image: BUNVIETNAME, // replace with Lachs image
            },
            F: {
                title: 'BUN VIETNAM - HAUSGEMACHTE LACHS FISCHBÄLLCHEN',
                description: 'Gefüllt mit Lachs Ball',
                price: '16,90 €',
                image: BUNVIETNAMF, // replace with Lachs image
            },
        },
    },
    {
        id: 56,
        code: '41',
        title: 'UDON XAO(F)',
        description: 'gebratene japanische Nudeln mit vers. Gemüse, Möhren, Sojasprossen. Gefüllt mit A.Entenfilets  B. Hühn C. Garnelen D. Rind E.Tofu F.Hühnchenbrust G.Große Garnalen',
        price: '15,90 €',
        category: 'main',
        image: UDONXAOA,
        variants: {
            A: {
                title: 'UDON XAO - KNUSPRIGE ENTENFILETSA(A,E,G)',
                description: 'Gefüllt mit Entenfilets',
                price: '15,90 €',
                image: UDONXAOA, // replace with actual Hühn image
            },
            B: {
                title: 'UDON XAO- HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
                image: UDONXAOB, // replace with Garnelen image
            },
            C: {
                title: 'UDON XAO - GARNELEN(B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: UDONXAOC,
            },
            D: {
                title: 'UDON XAO - RINDFLEISCH',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: UDONXAOD, // replace with Lachs image
            },
            E: {
                title: 'UDON XAO- Natur TOFU (F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: UDONXAOE,
            },
            F: {
                title: 'UDON XAO - PANIERTE HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit Hühnchenbrust',
                price: '13,90 €',
                image: UDONXAOF,
            },
            G: {
                title: 'UDON XAO - PANIERTE GROßE GARNELEN(A,B)',
                description: 'Gefüllt mit Große Garnalen',
                price: '15,90 €',
                image: UDONXAOG,
            },
        },
    },
    {
        id: 57,
        code: '42',
        title: 'MIEN XAO (F)',
        description: 'Gebratene Glasnudeln mit vers. Gemüse, Möhren, Sojaprossen. Gefüllt mit A.Entenfilets  B. Hühn C. Garnelen D. Rind E.Tofu F.Hühnchenbrust G.Große Garnalen ',
        price: '15,90 €',
        category: 'main',
        image: MIENXAOA,
        variants: {
            A: {
                title: 'MIEN XAO - KNUSPRIGE ENTENFILETSA(A,E,G)',
                description: 'Gefüllt mit Entenfilets',
                price: '15,90 €',
                image: MIENXAOA,
            },
            B: {
                title: 'MIEN XAO- HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
                image: MIENXAOF,
            },
            C: {
                title: 'MIEN XAO - GARNELEN(B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
                image: MIENXAOC,
            },
            D: {
                title: 'MIEN XAO - RINDFLEISCH',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
                image: MIENXAOD,
            },
            E: {
                title: 'MIEN XAO- Natur TOFU(F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
                image: MIENXAOE,
            },
            F: {
                title: 'MIEN XAO - PANIERTE HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit Hühnchenbrust',
                price: '13,90 €',
                image: MIENXAOB,
            },
            G: {
                title: 'MIEN XAO - PANIERTE GROßE GARNELEN(A,B)',
                description: 'Gefüllt mit Große Garnalen',
                price: '15,90 €',
                image: MIENXAOG,
            },
        },
    },

    {
        id: 175,
        code: '43',
        title: 'BUN TRON (F,H)',
        description: 'Reisnudeln mit Salat, frischen Kräutern, Röstzwiebeln und gerösteten Erdnüssen. Serviert mit hausgemachterm vietnamesischem Limetten-Fischsaucen-Dressing. Wahlseise mit: Gefüllt mit B. Hühn C. Garnelen E. Tofu L. Gegrillte Lachs ',
        price: '15,90 €',
        category: 'main',
        variants: {
            B: {
                title: 'BUN TRON - HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',

            },
            C: {
                title: 'BUN TRON - GARNELEN(B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',

            },
            E: {
                title: 'BUN TRON- Natur TOFU(F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',

            },
            L: {
                title: 'BUN TRON- GEGRILLTE LACHS(D)',
                description: 'Gefüllt mit Lachs',
                price: '18,90 €',

            },
        },
    },
    {
        id: 176,
        code: '44',
        title: 'PHO TRON LAC(F,H)',
        description: 'PHO TRON LAC F,H Flache Reisbandnudeln mit Salat, frischen Kräutern, Röstzwiebeln und gerösteten Erdnüssen. Serviert mit cremiger Erdnusssauce. Wahlseise mit: Gefüllt mit B. Hühn C. Garnelen D. Rind E. Tofu L. Gegrillte Lachs ',
        price: '15,90 €',
        category: 'main',
        variants: {
            B: {
                title: 'PHO TRON LAC - HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',

            },
            C: {
                title: 'PHO TRON LAC - GARNELEN(B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
            },
            D: {
                title: 'PHO TRON LAC- Rind(F)',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
            },
            E: {
                title: 'PHO TRON LAC- Natur TOFU(F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
            },
            L: {
                title: 'PHO TRON LAC- GEGRILLTE LACHS(D)',
                description: 'Gefüllt mit Lachs',
                price: '18,90 €',
            },
        },
    },
    {
        id: 177,
        code: '45',
        title: 'PHO TRON CURRY(F,H)',
        description: 'Flache Reisbandnudeln mit Salat, frischen Kräutern, Röstzwiebeln und gerösteten Erdnüssen. Serviert mit rot curry. Wahlseise mit: Gefüllt mit B. Hühn C. Garnelen D. Rind E. Tofu L. Gegrillte Lachs ',
        price: '15,90 €',
        category: 'main',
        variants: {
            B: {
                title: 'PHO TRON CURRY - HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '11,90 €',
            },
            C: {
                title: 'PHO TRON CURRY - GARNELEN(B,G)',
                description: 'Gefüllt mit Garnelen',
                price: '13,90 €',
            },
            D: {
                title: 'PHO TRON CURRY- Rind(F)',
                description: 'Gefüllt mit Rind',
                price: '13,90 €',
            },
            E: {
                title: 'PHO TRON CURRY- Natur TOFU(F)',
                description: 'Gefüllt mit Tofu',
                price: '12,90 €',
            },
            L: {
                title: 'PHO TRON CURRY- GEGRILLTE LACHS(D)',
                description: 'Gefüllt mit Lachs',
                price: '18,90 €',
            },
        },
    },
    {
        id: 58,
        code: '23',
        title: 'Natur TOFU XAO(F)',
        description: 'Frischer Natur Tofu mit vers. Gemüse.',
        price: '12,90€',
        category: 'vegetarischeSpeisen',
        image: BIOTOFUXAO
    },
    {
        id: 59,
        code: '26',
        title: 'GA CHAY',
        description: 'Im Wok geschwenkte Seitanstreifen in Chili-Zitronengras-Marinade.',
        price: '14,90€',
        category: 'vegetarischeSpeisen',
        image: GACHAY
    },
    {
        id: 60,
        code: '27',
        title: 'RAU XAO',
        description: 'Gedünstetes Gemüse mit Jasminreis.',
        price: '10,90€',
        category: 'vegetarischeSpeisen',
        image: RAUXAO
    },
    {
        id: 61,
        code: '31',
        title: 'DAU NAM',
        description: 'Natur Tofu mit ver. Gemüse in pikanter Sauce. Serviert mit Jasminreis.',
        price: '12,90€',
        category: 'vegetarischeSpeisen',
        image: BIOTOFUXAO
    },
    {
        id: 62,
        code: '32',
        title: 'COM DAU SESAM',
        description: 'Gebackene Natur Tofu mit Gemüse, Sesam. Serviert mit Jasminreis.',
        price: '14,90€',
        category: 'vegetarischeSpeisen',
        image: COMDAUSESAM
    },
    {
        id: 63,
        code: '35',
        title: 'COM XAO RAU(F)',
        description: 'Gebratenes Gemüse mit Hühnerfleisch.',
        price: '8,50€',
        category: 'kinderMenu',
        image: COMXAORAU
    },
    {
        id: 64,
        code: '36',
        title: 'GA XIEN(E)',
        description: '3 Hähnchenspieße mit Erdnusssoße, Salat und Reis.',
        price: '8,50€',
        category: 'kinderMenu',
        image: GAXIEN
    },
    {
        id: 65,
        code: '37',
        title: 'GOLDENE NUDELN(A,F)',
        description: 'Gebratene Nudeln mit vers. Gemüse, Eiern, Möhren, Sojasprossen. Gefüllt mit A. Hühn B.Hühnchenbrus ',
        price: '8,50 €',
        category: 'kinderMenu',
        image: GOLDENEA,
        variants: {
            A: {
                title: 'GOLDENE NUDELN - HÜHNERFILETS(G)',
                description: 'Gefüllt mit Hühn',
                price: '8,50 €',
                image: GOLDENEA,
            },
            B: {
                title: 'GOLDENE NUDELN- GEBACKEN HÄHNCHENBRUST(A)',
                description: 'Gefüllt mit Hühnchenbrust',
                price: '9,50 €',
                image: GOLDENEB,
            },
        },
    },
    {
        id: 66,
        code: '38',
        title: 'POMMES MIT GEBACKEN HÄHNCHENBRUST(A)',
        price: '9,50€',
        category: 'kinderMenu',
        image: POMMESMIT
    },
    {
        id: 67,
        code: '39',
        title: 'POMMES ',
        price: '5,90€',
        category: 'kinderMenu',
        image: Pommes
    },
    {
        id: 68,
        code: '43A',
        title: 'GEBACKENE BANANE MIT HONIG (A,M)',
        price: '5,90€',
        category: 'desserts',
        image: GEBACKENEBANANE
    },
    {
        id: 69,
        code: '43B',
        title: 'SESAMBÄLLCHEN (4 STK)',
        description: 'gefüllt mit Bohnenpast',
        price: '5,90€',
        category: 'desserts',
        image: SESAMBÄLLCHEN
    },
    {
        id: 70,
        code: '43C',
        title: 'MOCHI CAKE (3 STK.)(A)',
        price: '5,90€',
        category: 'desserts',
        image: mochCake

    },
    {
        id: 71,
        code: '43D',
        title: 'FRUCHT-MIX',
        description: 'Früchte mit Kondensmilch und Sesam',
        price: '6,90€',
        category: 'desserts',
        image: FRUCHTMIX
    },
    {
        id: 72,
        title: 'Jasminereis',
        price: '3,00€',
        category: 'extra',
        image: JASMINREIS
    },
    {
        id: 73,
        title: 'Reisnudeln',
        price: '3,00€',
        category: 'extra',
        image: REISNUDEL
    },
    {
        id: 74,
        title: 'Pommes',
        price: '3,90€',
        category: 'extra',
        image: Pommes
    },
    {
        id: 75,
        title: 'Süßkartoffelstreifen',
        price: '5,90€',
        category: 'extra',
        image: SUSSKARTOFEL
    },
    {
        id: 190,
        title: 'Knusprige Ente Crispy duck',
        price: '10,00€',
        category: 'extra'
    },
    {
        id: 191,
        title: 'Panierte Hähnchenbrust',
        price: '9,00€',
        category: 'extra'
    },
    {
        id: 76,
        title: 'Erdnusssoße',
        description: 'Gefüllt mit A. Klein  B. Große ',
        price: '1,00€',
        category: 'extra',
        image: Erdnessklein,
        variants: {
            A: {
                title: 'Erdnusssoße -Klein ',
                description: 'Gefüllt mit Klein',
                price: '1,00€',
                image: Erdnessklein,

            },
            B: {
                title: 'Erdnusssoße- Große',
                description: 'Gefüllt mit Große',
                price: '3,00€',
                image: Erdnussgross,

            },
        },

    },
    {
        id: 77,
        title: 'Currysoße',
        description: 'Gefüllt mit A. Klein  B. Große ',
        price: '1,00€',
        category: 'extra',
        image: Curryklein,
        variants: {
            A: {
                title: 'Currysoße -Klein ',
                description: 'Gefüllt mit Klein',
                price: '1,00€',
                image: Curryklein,

            },
            B: {
                title: 'Currysoße- Große ',
                description: 'Gefüllt mit Große ',
                price: '3,00€',
                image: Currygross,

            },
        },
    },
    {
        id: 78,
        title: 'Süß-Sauer-Soße',
        price: '1,00€',
        category: 'extra',
        image: Süßesauer,
    },
    {
        id: 79,
        title: 'Chilli Soße',
        price: '1,00€',
        category: 'extra',
    },
    {
        id: 80,
        title: 'Apfelsaft (5)',
        description: ' Fruchtsäfte mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: Apfelsaft,
        variants: {
            A: {
                title: 'Apfelsaft 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: Apfelsaft,
            },
            B: {

                title: 'Apfelsaft 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: Apfelsaft,
            },

        },
    },
    {
        id: 81,
        title: 'Bananensalf(5)',
        description: ' Fruchtsäfte mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: Bananensalf,
        variants: {
            A: {
                title: 'Bananensalf 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: Bananensalf,
            },
            B: {

                title: 'Bananensalf 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: Bananensalf,
            },

        },
    },

    {
        id: 82,
        title: 'Kiba',
        description: ' Fruchtsäfte mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: KIBA,
        variants: {
            A: {
                title: 'Kiba 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: KIBA,
            },
            B: {

                title: 'Kiba 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: KIBA,
            },

        },
    },
    {
        id: 83,
        title: 'Litschisaft',
        description: ' Fruchtsäfte mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: Litschisaft,
        variants: {
            A: {
                title: 'Litschisaft 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: Litschisaft,
            },
            B: {

                title: 'Litschisaft 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: Litschisaft,
            },

        },
    },
    {
        id: 84,
        title: 'Maracujasaft(5)',
        description: ' Fruchtsäfte mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: Maracujasaft,
        variants: {
            A: {
                title: 'Maracujasaft 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: Maracujasaft,
            },
            B: {

                title: 'Maracujasaft 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: Maracujasaft,
            },

        },
    },
    {
        id: 85,
        title: 'Mangosaft',
        description: ' Fruchtsäfte mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: Mangosaft,
        variants: {
            A: {
                title: 'Mangosaft 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: Mangosaft,
            },
            B: {

                title: 'Mangosaft 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: Mangosaft,
            },

        },
    },
    {
        id: 86,
        title: 'Kirschsalf(5)',
        description: ' Fruchtsäfte mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: Kirschsalf,
        variants: {
            A: {
                title: 'Kirschsalf 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: Kirschsalf,
            },
            B: {

                title: 'Kirschsalf 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: Kirschsalf,
            },

        },
    },
    {
        id: 87,
        title: 'Ginger Ale',
        description: ' Fruchtsäfte mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: GingerAle,
        variants: {
            A: {
                title: 'Ginger Ale 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: GingerAle,
            },
            B: {

                title: 'Ginger Ale 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: GingerAle,
            },

        },
    },
    {
        id: 88,
        title: 'Orangensaft',
        description: ' Fruchtsäfte mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: Orangensaft,
        variants: {
            A: {
                title: 'Orangensaft 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: Orangensaft,
            },
            B: {

                title: 'Orangensaft 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: Orangensaft,
            },

        },
    },
    {
        id: 89,
        title: 'Frisch gepresster Orangensaft',
        description: ' Fruchtsäfte mit A. 0.3l B. 0.5l',
        price: '4,50 €',
        category: 'getränke',
        image: Orangensaft,
        variants: {
            A: {
                title: 'Frisch gepresster Orangensaft 0,3l',
                description: '0,3l',
                price: '4,50 €',
                image: Orangensaft,
            },
            B: {

                title: 'Frisch gepresster Orangensaft 0,5l',
                description: '0,5l',
                price: '5,50 €',
                image: Orangensaft,
            },

        },
    },
    {
        id: 90,
        title: 'Frischer Limetttensaft mit Rohrzucker',
        description: ' Fruchtsäfte mit 0.5l',
        price: '5,50 €',
        category: 'getränke',
        image: lemonade,


    },

    {
        id: 91,
        title: 'Limetten- Minze mit Rohrzucker',
        description: 'Fruchtsäfte mit 0,5l',
        price: '  5,50€',
        category: 'getränke',
        image: limeminze
    },
    {
        id: 189,
        title: 'Zitronengras-Limetten mit Rohrzucker',
        description: 'Fruchtsäfte mit 0,5l',
        price: '  5,50€',
        category: 'getränke',
        image: limeminze
    },
    {
        id: 92,
        code: 'M6',
        title: 'Ebi Menü (C,D,F,I,M)',
        description: '2 Stück Ebi Nigiri, 6 Stück Ebi Maki, 8 Stück Ebi Tempura I.O',
        price: '  23,50€',
        category: 'sushi-menüs',
        subcategory: 'sushi-menüs',
        image: EbiMenü
    },
    {
        id: 93,
        title: 'Mango-Minze- Orange',
        description: 'Fruchtsäfte mit 0,5l',
        price: ' 5,50€',
        category: 'getränke',
        image: MangoOrange
    },
    {
        id: 94,
        title: 'Ananas-Minze-Maracuja',
        description: 'Fruchtsäfte mit 0,5l',
        price: '  5,50€',
        category: 'getränke',
        image: Ananasminze
    },
    {
        id: 95,
        title: 'Mango Lassi',
        description: 'mit Mango, Milch, Sahne, Joghurt, Zucker mit 0,5l',
        price: '  5,50€',
        category: 'getränke',
        image: Mangolassi
    },
    {
        id: 96,
        title: 'Lychee Lassi',
        description: 'mit Lychee, Milch, Kokosmilch, Joghurt, Zucker mit 0,5l',
        price: '  5,50€',
        category: 'getränke',
        image: lycheejuice
    },
    {
        id: 181,
        title: 'Very Berry',
        description: 'Black tea, strawberry, raspberry mit 0,5l',
        price: '  6,00€',
        category: 'getränke',
        image: VeryBerry,

    },
    {
        id: 182,
        title: 'Peachy Orange',
        description: 'Black tea, peach, orange mit 0,5l',
        price: '  6,00€',
        category: 'getränke',
        image: PeachOrange,

    },
    {
        id: 183,
        title: 'Lychee Lemonade',
        description: 'Green tea, lychee mit 0,5l',
        price: '  6,00€',
        category: 'getränke',
        image: LycheeLemonade,

    },
    {
        id: 184,
        title: 'Ginny Ginger',
        description: 'Green tea, lemon, ginger mit 0,5l',
        price: '  6,00€',
        category: 'getränke',
        image: GinyyGinger,

    },
    {
        id: 185,
        title: 'Tropical Beach',
        description: 'Green tea, mango, maracuja, pi    neapple mit 0,5l',
        price: '  6,00€',
        category: 'getränke',
        image: TropicalBeach,
    },
    {
        id: 186,
        title: 'Eis Tee',
        description: 'mit Zitrone 0,4l',
        price: '  3,00€',
        category: 'getränke',
        image: Zitrone

    },
    {
        id: 187,
        title: 'Eis Tee',
        description: 'mit Pfirsich 0,4l',
        price: '  3,00€',
        category: 'getränke',
        image: Pfirsich

    },
    {
        id: 188,
        title: 'Multi-Vitamin',
        description: 'mit 12-Fruchtsaftgetränk 0,5l',
        price: '  3,00€',
        category: 'getränke',
        image: MultiVitamin

    },

    {
        id: 97,
        title: 'Mineralwasser',
        description: ' Schorlen (mit oder ohne Kohlensäure). mit A. 0.3l B. 0.5l',
        price: '2,90 €',
        category: 'getränke',
        image: MineralwasserVio,
        variants: {
            A: {
                title: 'Mineralwasser 0,3l',
                description: '0,3l',
                price: '2,90 €',
                image: MineralwasserVio,
            },
            B: {

                title: 'Mineralwasser 0,5l',
                description: '0,5l',
                price: '3,50 €',
                image: MineralwasserVio,
            },

        },
    },
    {
        id: 98,
        title: 'Maracujaschorle(5)',
        description: ' Schorlen mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: Maracujaschorle,
        variants: {
            A: {
                title: 'Maracujaschorle 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: Maracujaschorle,
            },
            B: {

                title: 'Maracujaschorle 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: Maracujaschorle,
            },

        },
    },
    {
        id: 99,
        title: 'Mango-Maracujaschorle(5)',
        description: ' Schorlen mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: Mangosaft,
        variants: {
            A: {
                title: 'Mango-Maracujaschorle 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: Mangosaft,
            },
            B: {

                title: 'Mango-Maracujaschorle 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: Mangosaft,
            },

        },
    },
    {
        id: 100,
        title: 'Apfelschorle(5)',
        description: ' Schorlen mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: Apfelsaft,
        variants: {
            A: {
                title: 'Apfelschorle 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: Apfelsaft,
            },
            B: {

                title: 'Apfelschorle 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: Apfelsaft,
            },

        },
    },
    {
        id: 101,
        title: 'Kirschschorle(5)',
        description: ' Schorlen mit A. 0.3l B. 0.5l',
        price: '3,50 €',
        category: 'getränke',
        image: Kirschsalf,
        variants: {
            A: {
                title: 'Kirschschorle 0,3l',
                description: '0,3l',
                price: '3,50 €',
                image: Kirschsalf,
            },
            B: {

                title: 'Kirschschorle 0,5l',
                description: '0,5l',
                price: '4,50 €',
                image: Kirschsalf,
            },

        },
    },
    {
        id: 102,
        title: 'Asia Getränke',
        description: 'Schorlen mit 0,25l',
        price: '  2,90€',
        category: 'getränke',
    },
    {
        id: 103,
        title: 'Coca-Cola (1,2)',
        description: 'Erfrischungsgetränke mit 0,33l',
        price: '  2,90€ ',
        category: 'getränke',
        image: COLA
    },


    {
        id: 104,
        title: 'Coca-cola light(1,2,5)',
        description: 'Erfrischungsgetränke mit 0,33l',
        price: ' 2,90€ ',
        category: 'getränke',
        image: COLALIGHT
    },
    {
        id: 170,
        title: 'Cola-zero(1,2)',
        description: 'Erfrischungsgetränke mit 0,33l',
        price: '  2,90€ ',
        category: 'getränke',
        image: Colazero
    },
    {
        id: 105,
        title: 'Fanta (1,3)',
        description: 'Erfrischungsgetränke mit 0,33l',
        price: '  2,90€ ',
        category: 'getränke',
        image: Fanta
    },
    {
        id: 106,
        title: 'Sprite(1,2,3)',
        description: 'Erfrischungsgetränke mit 0,33l',
        price: ' 2,90€ ',
        category: 'getränke',
        image: Sprite
    },
    {
        id: 107,
        title: 'Tonic Water',
        description: 'Erfrischungsgetränke mit 0,33l',
        price: '  2,90€ ',
        category: 'getränke',
        image: TonicWater
    },

    {
        id: 108,
        title: 'Bitte Lemon',
        description: 'Erfrischungsgetränke mit 0,33l',
        price: '  2,90€ ',
        category: 'getränke',
        image: BitteLemon
    },

    {
        id: 109,
        title: 'Tra Xanh Thai Nguyen',
        description: ' Heisse getränke mit A.Tasse B.Kanne',
        price: '2,90 €',
        category: 'heissegetränke',
        image: TraXanhThaiNguyenTasse,
        variants: {
            A: {
                title: 'Tra Xanh Thai Nguyen Tasse',
                description: 'Tasse',
                price: '2,90 €',
                image: TraXanhThaiNguyenTasse,
            },
            B: {

                title: 'Tra Xanh Thai Nguyen Kanne',
                description: 'Kanne',
                price: '4,90 €',
                image: TraXanhThaiNguyenTasse,
            },

        },
    },
    {
        id: 110,
        title: 'Tra Hoa Nhai',
        description: ' Heisse getränke mit Jasmin Tee mit Jasminblütten. mit A.Tasse B.Kanne',
        price: '2,90 €',
        category: 'heissegetränke',
        image: TraHoaNhaiTasse,
        variants: {
            A: {
                title: 'Tra Hoa Nhai Tasse',
                description: 'Tasse',
                price: '2,90 €',
                image: TraHoaNhaiTasse,
            },
            B: {

                title: 'Tra Hoa Nhai Kanne',
                description: 'Kanne',
                price: '4,90 €',
                image: TraHoaNhaiTasse,
            },

        },
    },
    {
        id: 111,
        title: 'Tra Gung',
        description: ' Ein Kick für das Immunsystem:Frische Ingwerstückchen und frische Orange, Limetten, eine herrliche Mischung mit A.Tasse B.Kanne',
        price: '3,50 €',
        category: 'heissegetränke',
        image: TraGung,
        variants: {
            A: {
                title: 'Tra Gung Tasse',
                description: 'Tasse',
                price: '3,50 €',
                image: TraGung,
            },
            B: {

                title: 'Tra Gung Kanne',
                description: 'Kanne',
                price: '5,50 €',
                image: TraGung,
            },

        },
    },
    {
        id: 112,
        title: 'Tra Bac Ha',
        description: ' frische Minzblätte Mit Ingwerstreifen und Honig mit A.Tasse B.Kanne',
        price: '3,50 €',
        category: 'heissegetränke',
        image: TrabacHaw,
        variants: {
            A: {
                title: 'Tra Bac Ha Tasse',
                description: 'Tasse',
                price: '3,50 €',
                image: TrabacHaw,
            },
            B: {

                title: 'Tra Bac Ha Kanne',
                description: 'Kanne',
                price: '5,50 €',
                image: TrabacHaw,
            },

        },
    },
    {
        id: 113,
        title: 'Kaffee(2)',
        price: ' 2,90€  ',
        category: 'heissegetränke',
        image: Kaffee
    },

    {
        id: 114,
        title: 'Espresso (2)',
        price: ' 2,90€  ',
        category: 'heissegetränke',
        image: Espresso
    },
    {
        id: 115,
        title: 'Capuccino(2,G)',
        price: ' 3,50€  ',
        category: 'heissegetränke',
        image: Capuccino
    },
    {
        id: 116,
        title: 'Latte Macchiato(2,G)',
        price: ' 3,80€  ',
        category: 'heissegetränke',
        image: LatteMacchiato
    },
    {
        id: 117,
        title: 'Milchkaffee(2,G)',
        price: ' 2,90€  ',
        category: 'heissegetränke',
        image: Milchkaffee
    },
    {
        id: 118,
        title: 'Kaffee aus Vietnam',
        price: ' 2,90€  ',
        category: 'heissegetränke',
        image: KaffeeVietnam
    },
    {
        id: 119,
        title: 'Ca Phe Sua(2,4,G)',
        description: 'Kaffee mit Kondensmilch, durchläuft manueller Filter',
        price: ' 4,50€  ',
        category: 'heissegetränke',
        image: CaPheSua
    },
    {
        id: 120,
        title: 'Ca Phe Sua Da(2,4,G)',
        description: 'Eiskalt serviert, Kaffee mit Kondensmilch',
        price: ' 4,90€  ',
        category: 'heissegetränke',
        image: CaPheSuaDa
    },
    {
        id: 121,
        code: '91',
        title: 'Sake Maki (B)',
        description: 'Lachs',
        price: '6,00€',
        category: 'sushi-menüs',
        subcategory: 'maki',
        image: SakeMaki
    },
    {
        id: 122,
        code: '92',
        title: 'Sake Avocado',
        price: '6,50€',
        category: 'sushi-menüs',
        subcategory: 'maki',
        image: SakeAvocado
    },
    {
        id: 123,
        code: '93',
        title: 'Tekka Maki (B)',
        description: 'Thunfisch',
        price: '6,50€',
        category: 'sushi-menüs',
        subcategory: 'maki',
        image: TekkaMaki
    },
    {
        id: 124,
        code: '94',
        title: 'Ebi Maki',
        description: 'Garnelen',
        price: '6,50€',
        category: 'sushi-menüs',
        subcategory: 'maki',
        image: EbiMaki
    },
    {
        id: 125,
        code: '95',
        title: 'California Maki (B)',
        description: 'Surimi & Avocado',
        price: '6,50€',
        category: 'sushi-menüs',
        subcategory: 'maki',
        image: CaliforniaMaki
    },
    {
        id: 126,
        code: '96',
        title: 'Avocado Maki',
        price: '5,50€',
        category: 'sushi-menüs',
        subcategory: 'maki',
        image: AvocadoMaki
    },
    {
        id: 127,
        code: '97',
        title: 'Inari Maki (A,C)',
        description: 'Tofutasche',
        price: '5,50€',
        category: 'sushi-menüs',
        subcategory: 'maki',
        image: InariMaki
    },
    {
        id: 128,
        code: '98',
        title: 'California Special Maki (C)',
        description: 'Echtes Krebsfleisch, Mayonnaise und Lauch',
        price: '6,50€',
        category: 'sushi-menüs',
        subcategory: 'maki',
        image: CaliforniaSpecialMaki
    },
    {
        id: 129,
        code: '99',
        title: 'Kappa Maki',
        description: 'Echtes Krebsfleisch, Mayonnaise und Lauch',
        price: '5,50€',
        category: 'sushi-menüs',
        subcategory: 'maki',
        image: KappaMaki
    },
    {
        id: 180,
        code: '101',
        title: 'Paniert Hähnchen Maki baked',
        description: 'Mit Hünchenbrust',
        price: '6,50€',
        category: 'sushi-menüs',
        subcategory: 'maki',
        image: KappaMaki
    },
    {
        id: 130,
        code: '102',
        title: 'Tuna Maki (A,B)',
        description: 'gekochter Thunfisch, Lauch, Mayonnaise',
        price: '6,50€',
        category: 'sushi-menüs',
        subcategory: 'maki',
        image: TunaMaki
    },
    {
        id: 131,
        code: '103',
        title: 'Sashimi Mix (B,C)',
        description: '3 Scheiben Lachs, 3 Scheiben Thunfisch, 3 Stück Garnelen',
        price: '25,00€',
        category: 'sushi-menüs',
        subcategory: 'sashimi',
        image: SashmeiMix
    },
    {
        id: 132,
        code: '104',
        title: 'Sake Sashimi (B)',
        description: '6 Scheiben Lachs',
        price: '16,50€',
        category: 'sushi-menüs',
        subcategory: 'sashimi',
        image: SakeSashimi
    },
    {
        id: 133,
        code: '105',
        title: 'Tekka Sashimi (B)',
        description: '6 Scheiben Thunfisch',
        price: '17,50€',
        category: 'sushi-menüs',
        subcategory: 'sashimi',
        image: TekaSashemi
    },
    {
        id: 134,
        code: '108',
        title: 'Special Lachs Futo (B,D)',
        description: 'Lachs, Rucola, Gurke, Avocado, Chili, Frischkäse mit Soße',
        price: '10,50€',
        category: 'sushi-menüs',
        subcategory: 'futo-maki',
        image: SpecialLachsFuto
    },
    {
        id: 135,
        code: '109',
        title: 'Special Tekka Futo (B)',
        description: 'Thunfisch, Lauch, Gurke, Avocado, Chili und Soße',
        price: '11,50€',
        category: 'sushi-menüs',
        subcategory: 'futo-maki',
        image: SpecialLachsFuto
    },
    {
        id: 136,
        code: '110',
        title: 'Ebi Special Futo (C,D)',
        description: 'Garnelen gekocht, Lauch, Mayonnaise, Chili, Gurke, Avocado und Soße',
        price: '11,50€',
        category: 'sushi-menüs',
        subcategory: 'futo-maki',
        image: EbiSpecialFuto
    },
    {
        id: 137,
        code: '111',
        title: 'Special Futo (B,C,D)',
        description: 'Gebackene Garnelen, Aal, Frischkäse, Avocado, Gurke und Soße',
        price: '11,50€',
        category: 'sushi-menüs',
        subcategory: 'futo-maki',
        image: EbiSpecialFuto
    },
    {
        id: 138,
        code: '112',
        title: 'Tofu I.O (F)',
        description: 'Tofu, Rettich, Kürbis, Sesam',
        price: '10,50€',
        category: 'sushi-menüs',
        subcategory: 'inside-out',
        image: Tofu
    },
    {
        id: 139,
        code: '113',
        title: 'Teriyaki Sake I.O (A,B,C,D,F,I,M)',
        description: 'Gekochter Lachs, Gurke, lauch, frischkäse,Chili, Sesam, Unagi Sauce',
        price: '11,50€',
        category: 'sushi-menüs',
        subcategory: 'inside-out',
        image: TeriyakiSake
    },
    {
        id: 140,
        code: '114',
        title: 'Sake Avocado I.O (B,D)',
        description: 'Lachs, Avocado, Frischkäse und Tobikko',
        price: '10,50€',
        category: 'sushi-menüs',
        subcategory: 'inside-out',
        image: SakeAvocadoI
    },
    {
        id: 141,
        code: '115',
        title: 'Tekka Spicy I.O (B,D)',
        description: 'Thunfisch, Gurke, Lauch, Frischkäse, Chili, Tobikko',
        price: '11,50€',
        category: 'sushi-menüs',
        subcategory: 'inside-out',
        image: SakeAvocadoI
    },
    {
        id: 142,
        code: '116',
        title: 'California Special I.O (A,C)',
        description: 'Echtes Krebsfleisch, Mayonnaise, Lauch, Avocado und Tobikko',
        price: '11,50€',
        category: 'sushi-menüs',
        subcategory: 'inside-out',
        image: SakeAvocadoI
    },
    {
        id: 143,
        code: '117',
        title: 'Ebi Avocado I.O (A,C)',
        description: 'Garnelen, Avocado, Lauch, Mayonnaise und Tobikko',
        price: '11,50€',
        category: 'sushi-menüs',
        subcategory: 'inside-out',
        image: SakeAvocadoI
    },
    {
        id: 144,
        code: '118',
        title: 'California I.O (C,D)',
        description: 'Surimi, Avocado, Frischkäse und Tobikko',
        price: '10,50€',
        category: 'sushi-menüs',
        subcategory: 'inside-out',
        image: SakeAvocadoI
    },
    {
        id: 145,
        code: '119',
        title: 'Ebi Tempura I.O(C,D)',
        description: 'Gebackene Garnelen, Gurke und Frischkäse',
        price: '11,50€',
        category: 'sushi-menüs',
        subcategory: 'inside-out',
        image: EbiTempura
    },
    {
        id: 146,
        code: '120',
        title: 'Vegetarische I.O (F)',
        description: 'Avocado, Rettich, Gurke, Kürbis und Sesam',
        price: '10,50€',
        category: 'sushi-menüs',
        subcategory: 'inside-out',
        image: Vegetarische
    },
    {
        id: 147,
        code: '121',
        title: 'Rucola Kappa I.O (C,F)',
        description: 'Rucola, Gurke, Frischkäse und Sesam',
        price: '10,50€',
        category: 'sushi-menüs',
        subcategory: 'inside-out',
        image: RucolaKappa
    },
    {
        id: 148,
        code: '122',
        title: 'Paniert Hähnchen I.O  (B,C)',
        description: 'Paniert Hähnchen, Gurke, Frischkäse und Sauce',
        price: '11,50€',
        category: 'sushi-menüs',
        subcategory: 'inside-out',
        image: UnagiI
    },
    {
        id: 149,
        code: '123',
        title: 'Tuna I.O (A,B,D,F)',
        description: 'Gekochter Thunfisch, Lauch, Mayonnaise, Frischkäse, Chili und Sesam',
        price: '10,50€',
        category: 'sushi-menüs',
        subcategory: 'inside-out',
        image: TunaI
    },
    {
        id: 150,
        code: '124',
        title: 'Charge Roll(A,B,C,D,F,I,M)',
        description: 'Gekochte Garnelen, Mayonnaise, Gurke, Avocado, umwickelt mit Lachs mit A. 4 STK B.8 STK',
        price: '9,50€',
        category: 'sushi-menüs',
        subcategory: 'special-rolls',
        image: SPECIALROLL,
        variants: {
            A: {
                title: 'Charge Roll(A,B,C,D,F,I,M)',
                description: '4 STK',
                price: '9,50€',
                image: SPECIALROLLA,
            },
            B: {

                title: 'Charge Roll(A,B,C,D,F,I,M) ',
                description: '8 STK',
                price: '15,50€',
                image: SPECIALROLL,
            },
        },
    },
    {
        id: 151,
        code: '125',
        title: 'Dragon Roll(A,B,C,D,F,I,M)',
        description: 'Gebacken Garnelen, Frischkäse, Avocado, Gurke, Tobikko, umwickelt mit Lachs  mit A. 4 STK B.8 STK',
        price: '9,50€',
        category: 'sushi-menüs',
        subcategory: 'special-rolls',
        image: SPECIALROLL,
        variants: {
            A: {
                title: 'Dragon Roll(A,B,C,D,F,I,M)',
                description: '4 STK',
                price: '9,50€',
                image: SPECIALROLLA,
            },
            B: {

                title: 'Dragon Roll(A,B,C,D,F,I,M) ',
                description: '8 STK',
                price: '16,00€',
                image: SPECIALROLL,
            },
        },
    },
    {
        id: 152,
        code: '126',
        title: 'Best Friends Roll(A,B,C,D,F,I,M)',
        description: 'Gebackene Garnelen, Frischkäse, Avocado, Gurke, umwickelt mit flambierten Thunfisch, Lachs, Tobikko und Soße.mit A. 4 STK B.8 STK',
        price: '9,50€',
        category: 'sushi-menüs',
        subcategory: 'special-rolls',
        image: SPECIALROLL,
        variants: {
            A: {
                title: 'Best Friends Roll(A,B,C,D,F,I,M)',
                description: '4 STK',
                price: '9,50€',
                image: SPECIALROLLA,
            },
            B: {

                title: 'Best Friends Roll(A,B,C,D,F,I,M) ',
                description: '8 STK',
                price: '15,50€',
                image: SPECIALROLL,
            },

        },
    },
    {
        id: 153,
        code: '130',
        title: 'Rainbow Roll(A,B,C,D,F,I,M)',
        description: 'Surimi, Mayonnaise, Lauch, Gurke Avocado, umwickelt mit Lachs, Thunfisch mit Soße. mit A. 4 STK B.8 STK',
        price: '9,50€',
        category: 'sushi-menüs',
        subcategory: 'special-rolls',
        image: SPECIALROLL,
        variants: {
            A: {
                title: 'Rainbow Roll(A,B,C,D,F,I,M)',
                description: '4 STK',
                price: '9,50€',
                image: SPECIALROLLA,
            },
            B: {

                title: 'Rainbow Roll(A,B,C,D,F,I,M) ',
                description: '8 STK',
                price: '15,50€',
                image: SPECIALROLL,
            },
        },
    },
    {
        id: 154,
        code: '138',
        title: 'Lachs Bowl(A,B,C,D,F,I,M)',
        description: '4 Stk Sake Sashimi, Sake Tartar, Tobiko, Duftreis, frischen Salat, gekochtem Gemüse und hausgemachten Soßen, Sesam-',
        price: '17,90€',
        category: 'sushi-menüs',
        subcategory: 'chef-poke-bowl',
        image: LachsBowl
    },
    {
        id: 155,
        code: '139',
        title: 'Mix Bowl(A,B,C,D,F,I,M)',
        description: '3 Stk Sake Sashimi, 3 Stk Tekka Sashimi, 3 Stk Avocado, Tobiko Dufttreis, frischen Salat, gekochtem Gemüse und hausgemachten Soßen,Sesam',
        price: '19,90€',
        category: 'sushi-menüs',
        subcategory: 'chef-poke-bowl',
        image: MixBowl
    },
    {
        id: 156,
        code: '140',
        title: 'Garnelen Bowl(A,B,C,D,F,I,M)',
        description: '4 Stk Ebi Tempura Duftreis, frischen Salat, gekochtem Gemüse und hausgemachten Soßen, Sesam',
        price: '19,90€',
        category: 'sushi-menüs',
        subcategory: 'chef-poke-bowl',
        image: GarnelenBowl
    },
    {
        id: 157,
        code: '143',
        title: 'Tokyo Roll(A,B,C,D,F,I,M)',
        description: 'Tekka, Gurke, Avocado, Lauch, Gurke und Soße. mit A. 5 STK B.10 STK',
        price: '9,50€',
        category: 'sushi-menüs',
        subcategory: 'panierte-roll',
        image: PANIERTEROLL_B,
        variants: {
            A: {
                title: 'Tokyo Roll(A,B,C,D,F,I,M)',
                description: '5 STK',
                price: '9,50€',
                image: PANIERTEROLL_A,
            },
            B: {

                title: 'Tokyo Roll(A,B,C,D,F,I,M) ',
                description: '10 STK',
                price: '15,50€',
                image: PANIERTEROLL_B,
            },
        },
    },
    {
        id: 158,
        code: '144',
        title: 'Fuji Roll(A,C,D,F,I,M)',
        description: 'Echtes Krebsfleisch, Lauch, Chili, Frischkäse, Mayonnaise, Avocado, Gurke und Soße. mit A.5 STK B.10 STK',
        price: '9,50€',
        category: 'sushi-menüs',
        subcategory: 'panierte-roll',
        image: PANIERTEROLL_B,
        variants: {
            A: {
                title: 'Fuji Roll(A,C,D,F,I,M)',
                description: '5 STK',
                price: '9,50€',
                image: PANIERTEROLL_A,
            },
            B: {

                title: 'Fuji Roll(A,C,D,F,I,M) ',
                description: '10 STK',
                price: '15,50€',
                image: PANIERTEROLL_B,
            },
        },
    },
    {
        id: 159,
        code: '145',
        title: 'Special Roll(A,B,C,D,F,I,M)',
        description: 'gebackene Garnelen, Gurke, Frischkäse, Avocado und Soße. mit A. 5 STK B.10 STK',
        price: '9,50€',
        category: 'sushi-menüs',
        subcategory: 'panierte-roll',
        image: PANIERTEROLL_B,
        variants: {
            A: {
                title: 'Special Roll(A,B,C,D,F,I,M)',
                description: '5 STK',
                price: '9,50€',
                image: PANIERTEROLL_A,
            },
            B: {

                title: 'Special Roll(A,B,C,D,F,I,M) ',
                description: '10 STK',
                price: '15,50€',
                image: PANIERTEROLL_B,
            },
        },
    },
    {
        id: 160,
        code: '146',
        title: 'Chicken Roll(A,B,C,D,F,I,M)',
        description: 'geb. Hähnchen, Lauch, Frischkäse, Gurke, Avocado, Chili und Soße. mit A.5 STK B. 10 STK',
        price: '8,50€',
        category: 'sushi-menüs',
        subcategory: 'panierte-roll',
        image: PANIERTEROLL_B,
        variants: {
            A: {
                title: 'Chicken Roll(A,B,C,D,F,I,M)',
                description: '5 STK',
                price: '8,50€',
                image: PANIERTEROLL_A,
            },
            B: {

                title: 'Chicken Roll(A,B,C,D,F,I,M) ',
                description: '10 STK',
                price: ' 14,00€',
                image: PANIERTEROLL_B,
            },
        },
    },
    {
        id: 161,
        code: '147',
        title: 'Vegi Roll (D,F,I,M)',
        description: 'Avocado, Gurke, Rettich, Kürbis und Soße. mit A.5 STK B.10 STK',
        price: '7,50€ ',
        category: 'sushi-menüs',
        subcategory: 'panierte-roll',
        image: PANIERTEROLL_B,
        variants: {
            A: {
                title: 'Vegi Roll (D,F,I,M)',
                description: '5 STK',
                price: '7,50€ ',
                image: PANIERTEROLL_A,
            },
            B: {

                title: 'Vegi Roll (D,F,I,M) ',
                description: '10 STK',
                price: ' 13,50€',
                image: PANIERTEROLL_B,
            },
        },
    },
    {
        id: 162,
        code: '148',
        title: 'Tuna Roll (A,B,D,F,I,M)',
        description: 'Gekochter Thunfisch, Lauch, Avocado, Gurke, Mayonnaise, Frischkäse, Chili.mit A.5 STK B.10 STK',
        price: '8,50€',
        category: 'sushi-menüs',
        subcategory: 'panierte-roll',
        image: PANIERTEROLL_B,
        variants: {
            A: {
                title: 'Tuna Roll (A,B,D,F,I,M)',
                description: '5 STK',
                price: '8,50€',
                image: PANIERTEROLL_A,
            },
            B: {

                title: 'Tuna Roll (A,B,D,F,I,M) ',
                description: '10 STK',
                price: ' 14,50€',
                image: PANIERTEROLL_B,
            },
        },
    },
    {
        id: 163,
        code: '150',
        title: 'California Roll (A,B,C,D,F,I,M)',
        description: 'Surimi, Frischkäse, Avocado, Gurke und Soße mit A.5 STK B.10 STK',
        price: '8,50€',
        category: 'sushi-menüs',
        subcategory: 'panierte-roll',
        image: PANIERTEROLL_B,
        variants: {
            A: {
                title: 'California Roll (A,B,C,D,F,I,M)',
                description: '5 STK',
                price: '8,50€',
                image: PANIERTEROLL_A,
            },
            B: {

                title: 'California Roll (A,B,C,D,F,I,M) ',
                description: '10 STK',
                price: ' 14,50€',
                image: PANIERTEROLL_B,
            },
        },
    },
    {
        id: 164,
        title: 'Fritz kola',
        description: ' Fritz Kola 0.33l mit A.Original B.Orange C.Fritz light D.Fritz zero E.Honigmelone',
        price: '3,50 €',
        category: 'getränke',
        image: fritzoriginal,
        variants: {
            A: {
                title: 'Fritz kola original',
                description: 'Fritz kola original',
                price: '3,50 €',
                image: fritzoriginal,
            },
            B: {

                title: 'Fritz limo mit orange ',
                description: 'orange',
                price: '3,50 €',
                image: fitzorange,
            },
            C: {

                title: 'Fritz light',
                description: 'Fritz light',
                price: '3,50 €',
                image: fritzkola,
            },
            D: {

                title: 'Fritz zero',
                description: 'Fritz zero',
                price: '3,50 €',
                image: Superzero,
            },
            E: {

                title: 'Fritz Limo Honigmelone',
                description: 'Fritz limo',
                price: '3,50 €',
                image: LimoHonigmelone,
            },
        },
    },
    {
        id: 165,
        title: 'Cola Turka',
        description: '0.33l mit A.Cola Turka B.Uludag Gazoz C.Uludag Zero D.Uludag Orange',
        price: '3,00 €',
        category: 'getränke',
        image: ColaTurka,
        variants: {
            A: {
                title: 'Cola Turka ',
                description: 'Cola Turka original',
                price: '3,00 €',
                image: ColaTurka,
            },
            B: {

                title: 'Uludag Gazoz',
                description: 'Uludag Gazoz',
                price: '3,00 €',
                image: UludagGazoz,
            },
            C: {

                title: 'Uludag Zero',
                description: 'Uludag Gazoz',
                price: '3,00 €',
                image: Uludag_Gazoz_Zero,
            },
            D: {

                title: 'Uludag Orange',
                description: 'Uludag Gazoz',
                price: '3,00 €',
                image: Uludag_Orange,
            },




        },
    },
    {
        id: 166,
        code: 'M2',
        title: 'Charge Menü (B,C,F)',
        description: '1 skt Nigiri Sake, 1 skt Nigiri Tekka, 1 stk Nigiri Ebi, 6 stk Maki Avocado, 8 stk Sake Avo. I.O 6 stk. Lachs Avo. Panierte',
        price: '29,90€',
        category: 'sushi-menüs',
        subcategory: 'sushi-menüs',
        image: ChargeMenü
    },

    {
        id: 167,
        code: 'M3',
        title: 'Veggie Mix Menü (A,D,F,I,M)',
        description: '2 stk Nigiri Tofu, 1 stk Nigiri Avo, 6 stk Maki Avo, 8 stk Tofu I.O',
        price: '21,50€',
        category: 'sushi-menüs',
        subcategory: 'sushi-menüs',
        image: VeggieMixMenü
    },
    {
        id: 168,
        code: 'M4',
        title: 'Lachs Menü (A,B,D,F,I,M)',
        description: '2 Stück Nigiri Sake, 6 Stück Maki Sake, 8 St Sake Avo I.O 6 stk. Lachs Avo. Panierte',
        price: '31,90€',
        category: 'sushi-menüs',
        subcategory: 'sushi-menüs',
        image: LachsMenü
    },
    {
        id: 169,
        code: 'M5',
        title: 'Thunfisch Menü (A,B,D,F,I,M)',
        description: '2 Stück Tekka Nigiri, 6 Stück Tekka Maki, 8 Stk Tuna I.O.6 stk. Tuna Gurke Panierte',
        price: '32,90€',
        category: 'sushi-menüs',
        subcategory: 'sushi-menüs',
        image: ThunfischMenü
    },

    {
        id: 171,
        code: 'M9',
        title: ' Menü für 2 (A,B,C,D,F,I,M)',
        description: '(6 Stück Nigiri): 2 Sake, 2 Ebi, 2 Tekka (12 Stück Maki): 6 Maki Sake, 6 Maki Tuna 8 Stück Sake Avocado I.O. 10 Stück Lachs Pannierte Roll',
        price: '45,90€',
        category: 'sushi-menüs',
        subcategory: 'sushi-menüs',
        image: MenuFur2

    },
    {
        id: 172,
        title: 'Pikante Soße',
        description: 'Gefüllt mit A. Klein  B. Große',
        price: '1,00€',
        category: 'extra',
        variants: {
            A: {
                title: 'Pikante Soße - Klein ',
                description: 'Gefüllt mit Klein',
                price: '1,00€',

            },
            B: {
                title: 'Pikante Soße- Große',
                description: 'Gefüllt mit Große',
                price: '3,00€',
                image: Pikantegrosse,

            },
        },

    },
    {
        id: 173,
        title: 'CoctailSoße',
        price: '1,00€',
        category: 'extra',
        image: Coctail,
    },
    {
        id: 174,
        title: 'Unagi-Soße',
        price: '1,00€',
        category: 'extra',
        image: Unagie,
    },


];

initialMenuItems.forEach(item => {
    item.inStock = true;

    if (item.variants) {
        Object.keys(item.variants).forEach(variantKey => {
            item.variants[variantKey].inStock = true;
        });
    }
});


const OnlineBestellen = () => {
    const [noteInputVisibleFor, setNoteInputVisibleFor] = useState(null);
    const [tempNote, setTempNote] = useState('');
    //const [customerNote, setCustomerNote] = useState('');
    const [activeCategory, setActiveCategory] = useState('ALLE');
    const [activeSubcategory, setActiveSubcategory] = useState('ALLE');
    const [selectedItem, setSelectedItem] = useState(null);
    const { addToCart } = useCart();
    const [selectedVariants, setSelectedVariants] = useState({}); // store selected variant per item
    // New state for stock status with real-time updates
    const [stockStatus, setStockStatus] = useState({});
    const [menuItems, setMenuItems] = useState(initialMenuItems);
    const { t } = useTranslation();
    const list1 = t('orderSection.allergenBox.list1', { returnObjects: true });
    const list2 = t('orderSection.allergenBox.list2', { returnObjects: true });


    const categoryLabels = {
        'sushi-menüs': t('categories.sushiMenues'),
        main: t('categories.main'),
        getränke: t('categories.getraenke'),
        vorspeisen: t('categories.vorspeisen'),
        empfehlung: t('categories.empfehlung'),
        suppen: t('categories.suppen'),
        tapas: t('categories.tapas'),
        vegetarischeSpeisen: t('categories.vegetarischeSpeisen'),
        kinderMenu: t('categories.kinderMenu'),
        desserts: t('categories.desserts'),
        extra: t('categories.extra'),
        heissegetränke: t('categories.heissegetraenke')
    };

    const subCategoryLabels = {
        nigiri: t('subcategories.nigiri'),
        'futo-maki': t('subcategories.futoMaki'),
        maki: t('subcategories.maki'),
        sashimi: t('subcategories.sashimi'),
        'inside-out': t('subcategories.insideOut'),
        'special-rolls': t('subcategories.specialRolls'),
        'chef-poke-bowl': t('subcategories.chefPokeBowl'),
        'panierte-roll': t('subcategories.panierteRoll'),
        'sushi-menüs': t('subcategories.sushiMenues')
    };


    // Fetch initial stock status and setup real-time updates
    useEffect(() => {
        const API_BASE = getApiBaseUrl();

        // 1. Fetch initial stock status
        const fetchStockStatus = async () => {
            try {
                const response = await axios.get(`${API_BASE}/api/menu/stock`);
                const statusMap = response.data.reduce((acc, item) => {
                    acc[item.id] = item.inStock;
                    return acc;
                }, {});
                setStockStatus(statusMap);

                // Update menu items with initial status
                setMenuItems(prevItems =>
                    prevItems.map(item => ({
                        ...item,
                        inStock: statusMap[item.id] !== undefined ? statusMap[item.id] : item.inStock
                    }))
                );
            } catch (error) {
                console.error('Error fetching stock status:', error);
            }
        };

        fetchStockStatus();

        // 2. Setup real-time updates
        const eventSource = new EventSource(`${API_BASE}/api/menu/stock/updates`);

        const handleStockUpdate = (e) => {
            try {
                const updates = JSON.parse(e.data);
                console.log("Received stock updates:", updates);

                setStockStatus(prev => {
                    // Merge new updates with previous state
                    const newStatus = { ...prev, ...updates };

                    // Update menu items
                    setMenuItems(prevItems =>
                        prevItems.map(item => ({
                            ...item,
                            inStock: newStatus[item.id] !== undefined ? newStatus[item.id] : item.inStock
                        }))
                    );

                    return newStatus;
                });
            } catch (err) {
                console.error('Error parsing stock update:', err);
            }
        };

        eventSource.addEventListener('message', handleStockUpdate);

        eventSource.onerror = (e) => {
            console.error('SSE connection error:', e);
            eventSource.close();
        };

        return () => {
            eventSource.removeEventListener('message', handleStockUpdate);
            eventSource.close();
        };
    }, []);

    const categoryKeys = [...new Set(menuItems.map((item) => item.category))];
    const categories = ['ALLE', ...categoryKeys.map((key) => categoryLabels[key] || key.toUpperCase())];

    const isSushiMenu = activeCategory === 'SUSHI-MENÜS';
    const dynamicSubCategoryKeys = [
        ...new Set(
            menuItems.filter((item) => item.category === 'sushi-menüs' && item.subcategory).map((item) => item.subcategory)
        ),
    ];

    const getCategoryKey = (label) => {
        if (label === 'ALLE') return 'ALLE';
        const entry = Object.entries(categoryLabels).find(([_, val]) => val === label);
        return entry ? entry[0] : label.toLowerCase();
    };

    const getSubCategoryKey = (label) => {
        const entry = Object.entries(subCategoryLabels).find(([_, val]) => val === label);
        return entry ? entry[0] : label.toLowerCase();
    };

    const categoryKey = getCategoryKey(activeCategory);

    const filteredItems = menuItems.filter((item) => {
        const matchMain = categoryKey === 'ALLE' || item.category === categoryKey;
        const matchSub =
            !isSushiMenu ||
            activeSubcategory === 'ALLE' ||
            (item.subcategory && item.subcategory === getSubCategoryKey(activeSubcategory)) ||
            (item.category === 'sushi-menüs' && activeSubcategory === 'SUSHI-MENÜS');
        return matchMain && matchSub;
    });

    // Render description with clickable letters A, B, C, D inside
    const renderDescriptionWithClickableLetters = (item) => {
        if (!item.variants) {
            return <p>{item.description}</p>;
        }

        // Split the description before the first variant letter (A.)
        const baseText = item.description.split(/A\./)[0]?.trim();

        // Extract structured variant parts
        const parts = item.description.split(/([A-L]\.)/g);
        const structured = [];

        for (let i = 0; i < parts.length; i++) {
            if (/^[A-L]\.$/.test(parts[i])) {
                structured.push({
                    letter: parts[i][0],
                    content: parts[i + 1]?.trim() || '',
                });
                i++; // Skip the content just used
            }
        }

        const mid = Math.ceil(structured.length / 2);
        const columns = [structured.slice(0, mid), structured.slice(mid)];

        return (
            <>
                <p>{baseText}</p>
                <div className="variant-columns">
                    {columns.map((col, i) => (
                        <ul key={i}>
                            {col.map(({ letter, content }) => {
                                const isSelected = selectedVariants[item.id] === letter;
                                return (
                                    <li
                                        key={letter}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedVariants((prev) => ({
                                                ...prev,
                                                [item.id]: letter,
                                            }));
                                        }}
                                        style={{
                                            cursor: 'pointer',
                                            userSelect: 'none',
                                            color: isSelected ? 'red' : 'ivoary',
                                            fontWeight: isSelected ? 'bold' : 'normal',
                                            marginBottom: '6px',
                                        }}
                                        title={`Auswahl ${letter}`}
                                    >
                                        <strong>{letter}.</strong> {content}
                                    </li>
                                );
                            })}
                        </ul>
                    ))}
                </div>
            </>
        );
    };


    return (
        <section className="order-section">
            <div className="order-header">
                <button className="order-button">{t('orderSection.orderButton')}</button>
                <h2>{t('orderSection.orderHeading')}</h2>
                <div className="order-divider">{t('orderSection.divider')}</div>

                <div className="allergen-box">
                    <div className="allergen-heading">
                        {t('orderSection.allergenBox.heading')} <br />
                        <span className="subheading">{t('orderSection.allergenBox.subheading')}</span>
                    </div>

                    <div className="allergen-list">
                        <ul>
                            {list1.map((item, index) => (
                                <li key={`list1-${index}`}>{item}</li>
                            ))}
                        </ul>
                        <ul>
                            {list2.map((item, index) => (
                                <li key={`list2-${index}`}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            <div className="menu-tabs">
                {categories.map((cat) => (
                    <button
                        key={cat}
                        className={`tab ${activeCategory === cat ? 'active' : ''}`}
                        onClick={() => {
                            setActiveCategory(cat);
                            setActiveSubcategory('ALLE');
                        }}
                    >
                        {cat}
                    </button>
                ))}
            </div>

            {isSushiMenu && (
                <div className="submenu-tabs">
                    {['ALLE', ...dynamicSubCategoryKeys.map((key) => subCategoryLabels[key] || key.toUpperCase())].map((subcat) => (
                        <button
                            key={subcat}
                            className={`tab ${activeSubcategory === subcat ? 'active' : ''}`}
                            onClick={() => setActiveSubcategory(subcat)}
                        >
                            {subcat}
                        </button>
                    ))}
                </div>
            )}

            <div className="menu-items">
                {filteredItems.map((item) => {
                    const variantLetter = selectedVariants[item.id];
                    const displayData = variantLetter && item.variants ? item.variants[variantLetter] : item;
                    const isInStock = stockStatus[item.id] !== false; // treat undefined as in stock

                    return (
                        <div
                            className={`menu-item ${!isInStock ? 'out-of-stock' : ''}`}
                            key={item.id}
                            onClick={() => isInStock && setSelectedItem(displayData)}
                            style={{
                                cursor: isInStock ? 'pointer' : 'not-allowed',
                                opacity: isInStock ? 1 : 0.5, // optional greyed out style
                            }}
                        >
                            <img src={displayData.image} alt={displayData.title} />
                            <div className="item-content">
                                <h4>
                                    {displayData.title}
                                    <span>{displayData.price}</span>
                                </h4>
                                {renderDescriptionWithClickableLetters(item)}
                                {!isInStock && (
                                    <div style={{ color: 'red', marginTop: '0.3rem', fontWeight: 'bold' }}>
                                        Nicht verfügbar heute
                                    </div>
                                )}
                            </div>

                            {isInStock && (
                                <div
                                    className="plus-icon"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setNoteInputVisibleFor(item.id);
                                    }}
                                >
                                    <FaPlus />
                                </div>
                            )}

                            {noteInputVisibleFor === item.id && isInStock && (
                                <div
                                    className="note-input"
                                    style={{ marginTop: '0.5rem' }}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <textarea
                                        placeholder="Hinweis für dieses Gericht (optional)"
                                        rows={2}
                                        value={tempNote}
                                        onChange={(e) => setTempNote(e.target.value)}
                                        style={{
                                            width: '100%',
                                            padding: '0.5rem',
                                            borderRadius: '6px',
                                            fontSize: '0.9rem',
                                            border: '1px solid #ccc',
                                            resize: 'none',
                                        }}
                                    />
                                    <button
                                        style={{
                                            marginTop: '0.3rem',
                                            padding: '0.4rem 0.7rem',
                                            fontSize: '0.9rem',
                                            backgroundColor: '#333',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();

                                            if (item.variants && !selectedVariants[item.id]) {
                                                toast.warn('Bitte wählen Sie eine Variante aus.');
                                                return;
                                            }

                                            const variantLetter = selectedVariants[item.id];
                                            const sanitizedItem = {
                                                id: item.id,
                                                code: item.code || '',
                                                category: item.category,
                                                variantKey: variantLetter || null,
                                                variant: variantLetter ? item.variants[variantLetter] : null,
                                                variants: item.variants || null,
                                                price: parsePrice(variantLetter ? item.variants[variantLetter].price : item.price),
                                                note: tempNote.trim(),
                                                title: variantLetter ? `${item.title} (${variantLetter})` : item.title,
                                                image: variantLetter ? item.variants[variantLetter].image : item.image,
                                            };

                                            addToCart(sanitizedItem);
                                            setNoteInputVisibleFor(null);
                                            setTempNote('');
                                        }}

                                    >
                                        Hinzufügen
                                    </button>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            {selectedItem && (
                <div className="selected-item-popup">
                    <div className="popup-content">
                        <button onClick={() => setSelectedItem(null)}>X</button>
                        <img src={selectedItem.image} alt={selectedItem.title} />
                        <h3>
                            {selectedItem.title} <span>{selectedItem.price}</span>
                        </h3>
                        <p>{selectedItem.description}</p>
                    </div>
                </div>
            )}
        </section>
    );
};

export default OnlineBestellen; 
